var map_0d5da40de8d924d648e48bbfdd0bd93a = L.map(
  "map_0d5da40de8d924d648e48bbfdd0bd93a",
  {
    center: [8.98420985, 11.082930949999998],
    crs: L.CRS.EPSG3857,
    zoom: 12,
    zoomControl: true,
    preferCanvas: false,
  }
);

var tile_layer_03e5463fda3f7614d0652bb98b89167c = L.tileLayer(
  "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
  {
    attribution:
      '\u0026copy; \u003ca href="https://www.openstreetmap.org/copyright"\u003eOpenStreetMap\u003c/a\u003e contributors',
    detectRetina: false,
    maxNativeZoom: 19,
    maxZoom: 19,
    minZoom: 0,
    noWrap: false,
    opacity: 1,
    subdomains: "abc",
    tms: false,
  }
);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

map_0d5da40de8d924d648e48bbfdd0bd93a.fitBounds(
  [
    [-34.2109619, -17.4732781],
    [52.1793816, 39.63914],
  ],
  {}
);

var marker_cluster_110900f70bd3720a4c657036f1528ec7 = L.markerClusterGroup({});

var marker_ca2b1c7087e1c6cca8234efefa23502f = L.marker(
  [31.606445, -7.825859],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_9c38c709d199c8967ff1d8fdb622d22d = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_ca2b1c7087e1c6cca8234efefa23502f.setIcon(
  icon_9c38c709d199c8967ff1d8fdb622d22d
);

var popup_ebd636af5987583bc7b8ed959bf5652d = L.popup({ maxWidth: "100%" });

var html_394f27bc370c86af0ddc2e4ddc7e62af = $(
  `<div id="html_394f27bc370c86af0ddc2e4ddc7e62af" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Sidi Abdallah Ghiat<br>                     <strong>Country:</strong> Morocco<br>                     <strong>Post:</strong> Here is a short interview we gave to the Moroccan TV Station Chouf TV.  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1286448454770570/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 31.606445<br>                     <strong>Longitude:</strong> -7.825859<br>                     <strong>Date:</strong> Tuesday, 3th of January 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.99981<br>                 </div>             </div>`
)[0];
popup_ebd636af5987583bc7b8ed959bf5652d.setContent(
  html_394f27bc370c86af0ddc2e4ddc7e62af
);

marker_ca2b1c7087e1c6cca8234efefa23502f.bindPopup(
  popup_ebd636af5987583bc7b8ed959bf5652d
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var poly_line_bc62710ce431a8d5881b0830f59f705e = L.polyline(
  [[31.606445, -7.825859]],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_476763fa5a94ae1aa33ffaa36c5196b3 = L.marker(
  [33.535643, -7.78021],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_a483d106f728576a91ff493861678f46 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_476763fa5a94ae1aa33ffaa36c5196b3.setIcon(
  icon_a483d106f728576a91ff493861678f46
);

var popup_8e1bb8109a48fd7b93b139329b91c73e = L.popup({ maxWidth: "100%" });

var html_389f27109d0d7d0ef3f152f5295534cd = $(
  `<div id="html_389f27109d0d7d0ef3f152f5295534cd" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Dar Bouazza<br>                     <strong>Country:</strong> Morocco<br>                     <strong>Post:</strong> Here is a short interview we gave to the Moroccan TV Station Chouf TV.  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1286448454770570/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 33.535643<br>                     <strong>Longitude:</strong> -7.78021<br>                     <strong>Date:</strong> Thursday, 5th of January 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 97.57126<br>                 </div>             </div>`
)[0];
popup_8e1bb8109a48fd7b93b139329b91c73e.setContent(
  html_389f27109d0d7d0ef3f152f5295534cd
);

marker_476763fa5a94ae1aa33ffaa36c5196b3.bindPopup(
  popup_8e1bb8109a48fd7b93b139329b91c73e
);

var poly_line_5d4d1a216f29f5d92f6783450507187b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_5dc9e7e0d522b2e0d18e2556b1ab71bb = L.marker(
  [32.3140529, -9.2333757],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_bdbd9abf4e3464f8bd10cfec8709b0a5 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_5dc9e7e0d522b2e0d18e2556b1ab71bb.setIcon(
  icon_bdbd9abf4e3464f8bd10cfec8709b0a5
);

var popup_c224b50e09579e624de47cd09769b994 = L.popup({ maxWidth: "100%" });

var html_ad4ac77f5710d1cef4553f81f274832d = $(
  `<div id="html_ad4ac77f5710d1cef4553f81f274832d" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Safi<br>                     <strong>Country:</strong> Morocco<br>                     <strong>Post:</strong> Camping in Morocco next to the rare sleeping bag tree. 🐕 🐾  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1287237211358361/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 32.3140529<br>                     <strong>Longitude:</strong> -9.2333757<br>                     <strong>Date:</strong> Saturday, 7th of January 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 93.69941<br>                 </div>             </div>`
)[0];
popup_c224b50e09579e624de47cd09769b994.setContent(
  html_ad4ac77f5710d1cef4553f81f274832d
);

marker_5dc9e7e0d522b2e0d18e2556b1ab71bb.bindPopup(
  popup_c224b50e09579e624de47cd09769b994
);

var poly_line_5a8851cd640b2ec5f1716c3df7cc817b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_543c7ec31cd1b21e28029800859713c6 = L.marker(
  [31.3524003, -9.7949087],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_6f7a82ea3597a19dccafec676c4f087e = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_543c7ec31cd1b21e28029800859713c6.setIcon(
  icon_6f7a82ea3597a19dccafec676c4f087e
);

var popup_1b741fda081657cba1f2f0e76bbd3704 = L.popup({ maxWidth: "100%" });

var html_0dd3fa9023260f7c05d6098f23ec014b = $(
  `<div id="html_0dd3fa9023260f7c05d6098f23ec014b" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Essaouira<br>                     <strong>Country:</strong> Morocco<br>                     <strong>Post:</strong> Had to get some film of Indigo & Mayo setting off🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsO<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1291914327557316" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 31.3524003<br>                     <strong>Longitude:</strong> -9.7949087<br>                     <strong>Date:</strong> Monday, 9th of January 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.87526<br>                 </div>             </div>`
)[0];
popup_1b741fda081657cba1f2f0e76bbd3704.setContent(
  html_0dd3fa9023260f7c05d6098f23ec014b
);

marker_543c7ec31cd1b21e28029800859713c6.bindPopup(
  popup_1b741fda081657cba1f2f0e76bbd3704
);

var poly_line_2333ef802d98d020774bc552e4585ec2 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_28ecdf8c5d9b7fb9b6fc038f3de79251 = L.marker(
  [30.42606, -9.59188],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_f1048e57e9b10b6e49055038f3344e1f = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_28ecdf8c5d9b7fb9b6fc038f3de79251.setIcon(
  icon_f1048e57e9b10b6e49055038f3344e1f
);

var popup_031adb949c3681a455ca44421f57e58a = L.popup({ maxWidth: "100%" });

var html_9f23f8486eb9d6e544790a77b4db313e = $(
  `<div id="html_9f23f8486eb9d6e544790a77b4db313e" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Agadir<br>                     <strong>Country:</strong> Morocco<br>                     <strong>Post:</strong> Hanging out in Morocco The Pack Track are having a blast touring around the Agadir region of Morocco, if you happen to be within the vaccinity then please get in touch. #MadeToTravel #Cute #Dog #Adven<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1294502760631806/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 30.42606<br>                     <strong>Longitude:</strong> -9.59188<br>                     <strong>Date:</strong> Saturday, 14th of January 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_031adb949c3681a455ca44421f57e58a.setContent(
  html_9f23f8486eb9d6e544790a77b4db313e
);

marker_28ecdf8c5d9b7fb9b6fc038f3de79251.bindPopup(
  popup_031adb949c3681a455ca44421f57e58a
);

var poly_line_a8ade597988b315634c46e0fc88dabd8 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_dde0cf6ad15946de010ab72ba8c9aab2 = L.marker(
  [28.49085, -11.33771],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_6e5d455fc62390c985e52021460091b7 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_dde0cf6ad15946de010ab72ba8c9aab2.setIcon(
  icon_6e5d455fc62390c985e52021460091b7
);

var popup_d9efccc3b776eb7cde9787938d371a09 = L.popup({ maxWidth: "100%" });

var html_37fc7db2ecc45b53ca7f4c6fd1a8b4ce = $(
  `<div id="html_37fc7db2ecc45b53ca7f4c6fd1a8b4ce" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Tan-Tan<br>                     <strong>Country:</strong> Morocco<br>                     <strong>Post:</strong> Our neighbours this evening🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdopti<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1298877840194298/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 28.49085<br>                     <strong>Longitude:</strong> -11.33771<br>                     <strong>Date:</strong> Friday, 20th of January 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_d9efccc3b776eb7cde9787938d371a09.setContent(
  html_37fc7db2ecc45b53ca7f4c6fd1a8b4ce
);

marker_dde0cf6ad15946de010ab72ba8c9aab2.bindPopup(
  popup_d9efccc3b776eb7cde9787938d371a09
);

var poly_line_0b2ff52ffe489bdc85f719bf5b4ed792 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_64668716356f38196eb3b320404d09f8 = L.marker(
  [27.952836, -12.865686],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_87ebfd822f2981e11f1f61d8e98f5018 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_64668716356f38196eb3b320404d09f8.setIcon(
  icon_87ebfd822f2981e11f1f61d8e98f5018
);

var popup_4a4b222435c04a29fe09507cea6c196f = L.popup({ maxWidth: "100%" });

var html_cde4950612e6cb14f5651ece56428d87 = $(
  `<div id="html_cde4950612e6cb14f5651ece56428d87" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Tarfaya<br>                     <strong>Country:</strong> Morocco<br>                     <strong>Post:</strong> Camp cooking. When the sun goes down there's nothing better to do but take 2 hours to cook dinner listening to the Rat Pack 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventure<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1299689050113177/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 27.952836<br>                     <strong>Longitude:</strong> -12.865686<br>                     <strong>Date:</strong> Saturday, 21th of January 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_4a4b222435c04a29fe09507cea6c196f.setContent(
  html_cde4950612e6cb14f5651ece56428d87
);

marker_64668716356f38196eb3b320404d09f8.bindPopup(
  popup_4a4b222435c04a29fe09507cea6c196f
);

var poly_line_9acd0773845cb90805501765321373b3 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_2522e199edfe2d0edeb2f16269695ec0 = L.marker(
  [26.13262, -14.49496],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_5f723b6b1a8079ae685651efeefe5adf = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_2522e199edfe2d0edeb2f16269695ec0.setIcon(
  icon_5f723b6b1a8079ae685651efeefe5adf
);

var popup_977ffa78587a5d4ff28805b22c07b26d = L.popup({ maxWidth: "100%" });

var html_ba5519cdcd8e356f13f97b0f3c721593 = $(
  `<div id="html_ba5519cdcd8e356f13f97b0f3c721593" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Laayoune Plage<br>                     <strong>Country:</strong> Western Sahara<br>                     <strong>Post:</strong> Tropic of Cancer in Western Sahara. 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1302782469803835/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 26.13262<br>                     <strong>Longitude:</strong> -14.49496<br>                     <strong>Date:</strong> Monday, 23th of January 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_977ffa78587a5d4ff28805b22c07b26d.setContent(
  html_ba5519cdcd8e356f13f97b0f3c721593
);

marker_2522e199edfe2d0edeb2f16269695ec0.bindPopup(
  popup_977ffa78587a5d4ff28805b22c07b26d
);

var poly_line_ff0863e65b5f45645981091f12974aec = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_8ef4683c100dc79f497c8f0d75266b1d = L.marker(
  [23.78181, -15.90115],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_3747709d2042beb52f02d68140a7bcc9 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_8ef4683c100dc79f497c8f0d75266b1d.setIcon(
  icon_3747709d2042beb52f02d68140a7bcc9
);

var popup_5a1cff409eb9af91ba86d767cdc084e1 = L.popup({ maxWidth: "100%" });

var html_358f994f535ce7f238798e1d1a881678 = $(
  `<div id="html_358f994f535ce7f238798e1d1a881678" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Dakhla<br>                     <strong>Country:</strong> Western Sahara<br>                     <strong>Post:</strong> Tropic of Cancer in Western Sahara. 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1302782469803835/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 23.78181<br>                     <strong>Longitude:</strong> -15.90115<br>                     <strong>Date:</strong> Tuesday, 24th of January 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_5a1cff409eb9af91ba86d767cdc084e1.setContent(
  html_358f994f535ce7f238798e1d1a881678
);

marker_8ef4683c100dc79f497c8f0d75266b1d.bindPopup(
  popup_5a1cff409eb9af91ba86d767cdc084e1
);

var poly_line_f216738824825f408b3585561952aed7 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_e4f711c3315340873ec42cff26ef4476 = L.marker(
  [22.05488, -16.74722],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_106699f55c5fc4fd8ad489cbd2976b3f = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_e4f711c3315340873ec42cff26ef4476.setIcon(
  icon_106699f55c5fc4fd8ad489cbd2976b3f
);

var popup_3b26bac32a868450b4b7c21eae0e169d = L.popup({ maxWidth: "100%" });

var html_be88b0b175904c0239db806f8465948a = $(
  `<div id="html_be88b0b175904c0239db806f8465948a" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Nouadhibou<br>                     <strong>Country:</strong> Mauritania<br>                     <strong>Post:</strong> Tropic of Cancer in Western Sahara. 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1302782469803835/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 22.05488<br>                     <strong>Longitude:</strong> -16.74722<br>                     <strong>Date:</strong> Wednesday, 25th of January 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_3b26bac32a868450b4b7c21eae0e169d.setContent(
  html_be88b0b175904c0239db806f8465948a
);

marker_e4f711c3315340873ec42cff26ef4476.bindPopup(
  popup_3b26bac32a868450b4b7c21eae0e169d
);

var poly_line_75d92d6e6842e311b412de91367b7fbe = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_2d74a419b98331c0b064705370017caf = L.marker(
  [20.9245, -16.21606],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_b174c2fd472d3d6434a07880dfa642ed = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_2d74a419b98331c0b064705370017caf.setIcon(
  icon_b174c2fd472d3d6434a07880dfa642ed
);

var popup_ee9c5bb917b106a47c8794e6f40b0c33 = L.popup({ maxWidth: "100%" });

var html_18aa06a85b058d266bbe602db3a127b8 = $(
  `<div id="html_18aa06a85b058d266bbe602db3a127b8" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Nouadhibou<br>                     <strong>Country:</strong> Mauritania<br>                     <strong>Post:</strong> First night in Mauritania 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoptio<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1305778086170940/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 20.9245<br>                     <strong>Longitude:</strong> -16.21606<br>                     <strong>Date:</strong> Thursday, 26th of January 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_ee9c5bb917b106a47c8794e6f40b0c33.setContent(
  html_18aa06a85b058d266bbe602db3a127b8
);

marker_2d74a419b98331c0b064705370017caf.bindPopup(
  popup_ee9c5bb917b106a47c8794e6f40b0c33
);

var poly_line_5ba131992b6914aadc0057e37cd7728c = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_2e26bc7de0411e5ef9d62ac7e84aa2fd = L.marker(
  [18.11173, -16.0264],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_ce0a8e5bd0b5b507133dc24c592d7aff = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_2e26bc7de0411e5ef9d62ac7e84aa2fd.setIcon(
  icon_ce0a8e5bd0b5b507133dc24c592d7aff
);

var popup_d5243e61eeb508edad991b06d881a800 = L.popup({ maxWidth: "100%" });

var html_929b1b2ae4b1301237a404458131fc3f = $(
  `<div id="html_929b1b2ae4b1301237a404458131fc3f" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Nouakchott<br>                     <strong>Country:</strong> Mauritania<br>                     <strong>Post:</strong> First night in Mauritania 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoptio<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1305778086170940/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 18.11173<br>                     <strong>Longitude:</strong> -16.0264<br>                     <strong>Date:</strong> Friday, 27th of January 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_d5243e61eeb508edad991b06d881a800.setContent(
  html_929b1b2ae4b1301237a404458131fc3f
);

marker_2e26bc7de0411e5ef9d62ac7e84aa2fd.bindPopup(
  popup_d5243e61eeb508edad991b06d881a800
);

var poly_line_9522d42c3f0603226a09a8eadea55c59 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_ea4e3613d15bc7ef11c4b12b751264c9 = L.marker(
  [16.22107, -16.41449],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_decd78d92893eed50991d800958d6d2a = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_ea4e3613d15bc7ef11c4b12b751264c9.setIcon(
  icon_decd78d92893eed50991d800958d6d2a
);

var popup_78c29fc089a5eb1101231293ce5ccb96 = L.popup({ maxWidth: "100%" });

var html_ff3f5371bcaa21937d481c840008fe77 = $(
  `<div id="html_ff3f5371bcaa21937d481c840008fe77" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Saint-Louis<br>                     <strong>Country:</strong> Senegal<br>                     <strong>Post:</strong> How to protect a fuel line on the go 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW <br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1307109349371147" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 16.22107<br>                     <strong>Longitude:</strong> -16.41449<br>                     <strong>Date:</strong> Saturday, 28th of January 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_78c29fc089a5eb1101231293ce5ccb96.setContent(
  html_ff3f5371bcaa21937d481c840008fe77
);

marker_ea4e3613d15bc7ef11c4b12b751264c9.bindPopup(
  popup_78c29fc089a5eb1101231293ce5ccb96
);

var poly_line_a711444a12fc1d235932ef10b777fc3a = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_84eb584b0eaa41cdc266c726024a0255 = L.marker(
  [14.6899365, -17.4732781],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_195b5be7a6788301a6c80b16fa898114 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_84eb584b0eaa41cdc266c726024a0255.setIcon(
  icon_195b5be7a6788301a6c80b16fa898114
);

var popup_6ea423e97be736f4ab7d75bf87b8bbb2 = L.popup({ maxWidth: "100%" });

var html_0a24370cf9d7c07be059d679e0c80a12 = $(
  `<div id="html_0a24370cf9d7c07be059d679e0c80a12" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mermoz Boabab<br>                     <strong>Country:</strong> Senegal<br>                     <strong>Post:</strong> Sneaky video taken at the Mauritania to Senegal border crossing. We arrived in the dark after our fuel line issue and camped on the road directly outside the Douane. This video was taken while no one <br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1310252479056834" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 14.6899365<br>                     <strong>Longitude:</strong> -17.4732781<br>                     <strong>Date:</strong> Tuesday, 31th of January 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 98.396416<br>                 </div>             </div>`
)[0];
popup_6ea423e97be736f4ab7d75bf87b8bbb2.setContent(
  html_0a24370cf9d7c07be059d679e0c80a12
);

marker_84eb584b0eaa41cdc266c726024a0255.bindPopup(
  popup_6ea423e97be736f4ab7d75bf87b8bbb2
);

var poly_line_5c5d3fbf9e8ab64571addaf00afccd77 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_5121f37e304755106c5983cbfb50668e = L.marker(
  [13.977, -14.81747],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_6b1d416f4ab8e18f610d589dde150b99 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_5121f37e304755106c5983cbfb50668e.setIcon(
  icon_6b1d416f4ab8e18f610d589dde150b99
);

var popup_6244065740beb0dd605449e50257a15e = L.popup({ maxWidth: "100%" });

var html_705bd4eba606a71e59601b72a868966b = $(
  `<div id="html_705bd4eba606a71e59601b72a868966b" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Koungheul<br>                     <strong>Country:</strong> Senegal<br>                     <strong>Post:</strong> Stuart took a friend of the family we stayed with for a ride on his bike. The boy was initially afraid of the dogs but became best friends before long and was happy for them to ride just behind him. 🐾<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1314480108634071/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 13.977<br>                     <strong>Longitude:</strong> -14.81747<br>                     <strong>Date:</strong> Saturday, 4th of February 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_6244065740beb0dd605449e50257a15e.setContent(
  html_705bd4eba606a71e59601b72a868966b
);

marker_5121f37e304755106c5983cbfb50668e.bindPopup(
  popup_6244065740beb0dd605449e50257a15e
);

var poly_line_902c861c891cec06eda72ff60dd92699 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_23e926742d339d1d50337b45a8dd262e = L.marker(
  [12.9016087, -14.947223],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_6b4cad6aef6eb08dd0b1083f92d33664 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_23e926742d339d1d50337b45a8dd262e.setIcon(
  icon_6b4cad6aef6eb08dd0b1083f92d33664
);

var popup_3dcdbb914cfa23bef309a0ad21a1e5f3 = L.popup({ maxWidth: "100%" });

var html_4f29f8781e416da586f993ab5f1feaf5 = $(
  `<div id="html_4f29f8781e416da586f993ab5f1feaf5" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kolda<br>                     <strong>Country:</strong> Senegal<br>                     <strong>Post:</strong> Stuart took a friend of the family we stayed with for a ride on his bike. The boy was initially afraid of the dogs but became best friends before long and was happy for them to ride just behind him. 🐾<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1314480108634071/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 12.9016087<br>                     <strong>Longitude:</strong> -14.947223<br>                     <strong>Date:</strong> Sunday, 5th of February 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_3dcdbb914cfa23bef309a0ad21a1e5f3.setContent(
  html_4f29f8781e416da586f993ab5f1feaf5
);

marker_23e926742d339d1d50337b45a8dd262e.bindPopup(
  popup_3dcdbb914cfa23bef309a0ad21a1e5f3
);

var poly_line_b09a2deb904c321a3dd5cde5de73e489 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b541e5d7c5ddb6953a05e08515191521 = L.marker(
  [13.26055, -13.20166],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_6557d4127a393d44043b4b313b560320 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b541e5d7c5ddb6953a05e08515191521.setIcon(
  icon_6557d4127a393d44043b4b313b560320
);

var popup_031ddb90f2f3b020afbcda0e1cb5a779 = L.popup({ maxWidth: "100%" });

var html_a3716dac61ebc67e1808d92be889c969 = $(
  `<div id="html_a3716dac61ebc67e1808d92be889c969" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Sun Kunda<br>                     <strong>Country:</strong> Gambia<br>                     <strong>Post:</strong> The man himself. ..Souleymane. Extremist militants in the south of Senegal kept him busy in the bush. He was unable to be released to see us in Dakar so we went to him. We spent 2 days with Souleymane<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1316403948441687/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 13.26055<br>                     <strong>Longitude:</strong> -13.20166<br>                     <strong>Date:</strong> Tuesday, 7th of February 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_031ddb90f2f3b020afbcda0e1cb5a779.setContent(
  html_a3716dac61ebc67e1808d92be889c969
);

marker_b541e5d7c5ddb6953a05e08515191521.bindPopup(
  popup_031ddb90f2f3b020afbcda0e1cb5a779
);

var poly_line_17b1b3d6623623f7319fdfd0eed4bad0 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_860ea4e4135d93d31fea61e17b16c30d = L.marker(
  [12.67946, -11.09744],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_74d864e20140472eb4bb95b39cb5b5ff = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_860ea4e4135d93d31fea61e17b16c30d.setIcon(
  icon_74d864e20140472eb4bb95b39cb5b5ff
);

var popup_763e755ed2b22d9c09228bc58d5b8565 = L.popup({ maxWidth: "100%" });

var html_b4df2a11d66625f3e202660dd0c06c4e = $(
  `<div id="html_b4df2a11d66625f3e202660dd0c06c4e" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Dire<br>                     <strong>Country:</strong> Mali<br>                     <strong>Post:</strong> We're in Mali! Easiest border crossing ever; visa's were obtained at the embassy in Dakar so we simply stamoed out of Senegal and in to Mali. There was no paperwork for the motorbikes.  The scenery ha<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1317633631652052/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 12.67946<br>                     <strong>Longitude:</strong> -11.09744<br>                     <strong>Date:</strong> Wednesday, 8th of February 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_763e755ed2b22d9c09228bc58d5b8565.setContent(
  html_b4df2a11d66625f3e202660dd0c06c4e
);

marker_860ea4e4135d93d31fea61e17b16c30d.bindPopup(
  popup_763e755ed2b22d9c09228bc58d5b8565
);

var poly_line_3f90733ea4a8a4c8f201c02704135961 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_d68ba9d2094cf53e06f0fa96a09fa355 = L.marker(
  [12.625496, -7.988058],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_64f02c7b0ba3105a4cb719189f0698b4 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_d68ba9d2094cf53e06f0fa96a09fa355.setIcon(
  icon_64f02c7b0ba3105a4cb719189f0698b4
);

var popup_5d8dd2c8a036354a7f7d3a456e295006 = L.popup({ maxWidth: "100%" });

var html_bb2ddda431fa08bb5ef5bd80a3a74252 = $(
  `<div id="html_bb2ddda431fa08bb5ef5bd80a3a74252" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Bamako<br>                     <strong>Country:</strong> Mali<br>                     <strong>Post:</strong> How to bring an #F650GS back from the dead. 2 km from our destination, it's 8pm and Janell's 4th bike problem of the day (3rd was overheating from a broken fan) and the bike just dies. Roadside Stu to<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1319098048172277" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 12.625496<br>                     <strong>Longitude:</strong> -7.988058<br>                     <strong>Date:</strong> Friday, 10th of February 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.44089<br>                 </div>             </div>`
)[0];
popup_5d8dd2c8a036354a7f7d3a456e295006.setContent(
  html_bb2ddda431fa08bb5ef5bd80a3a74252
);

marker_d68ba9d2094cf53e06f0fa96a09fa355.bindPopup(
  popup_5d8dd2c8a036354a7f7d3a456e295006
);

var poly_line_b86df236fb5151e0066ea3c5d0b3db6b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_2754fb0dbd3e1c789035517d9c435059 = L.marker(
  [10.84124, -4.78226],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_106810022d1b8dec83c09ed6a769a1cc = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_2754fb0dbd3e1c789035517d9c435059.setIcon(
  icon_106810022d1b8dec83c09ed6a769a1cc
);

var popup_89cc9d085e51d5d8e1ee782201c23a88 = L.popup({ maxWidth: "100%" });

var html_5b9da47f7e21475c8df736873bca0659 = $(
  `<div id="html_5b9da47f7e21475c8df736873bca0659" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Orodara<br>                     <strong>Country:</strong> Burkina Faso<br>                     <strong>Post:</strong> Big day. Massive day. 480km and a border crossing.  We rode from Bamako in Mali to Orodara in Burkina Faso and it was some hot riding. This is a quick water break on the side of the road. 🐾 🐕  #Pillio<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1325344297547652/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 10.84124<br>                     <strong>Longitude:</strong> -4.78226<br>                     <strong>Date:</strong> Saturday, 18th of February 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_89cc9d085e51d5d8e1ee782201c23a88.setContent(
  html_5b9da47f7e21475c8df736873bca0659
);

marker_2754fb0dbd3e1c789035517d9c435059.bindPopup(
  popup_89cc9d085e51d5d8e1ee782201c23a88
);

var poly_line_6ef5ca157db220e8d5d43aa236ec704b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_a4eaea379a2eb3e232f833cc7adc7db2 = L.marker(
  [11.7508293, -2.9289838],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_f0487957846a7265d6075a8d205bc4d0 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_a4eaea379a2eb3e232f833cc7adc7db2.setIcon(
  icon_f0487957846a7265d6075a8d205bc4d0
);

var popup_380091aba30004d0c21f12b5edd46428 = L.popup({ maxWidth: "100%" });

var html_ff16d823eab738a9a03d7753187ff3ca = $(
  `<div id="html_ff16d823eab738a9a03d7753187ff3ca" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Boromo<br>                     <strong>Country:</strong> Burkina Faso<br>                     <strong>Post:</strong> Full bellies!! We were so fortunate to have Miyu and Ines host us in Ouagadougou (Capital of Burkina Faso) for 2 nights. Ines spent 2 hours preparing the most tastey dinner we've had in Africa; gourme<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1329570793791669/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 11.7508293<br>                     <strong>Longitude:</strong> -2.9289838<br>                     <strong>Date:</strong> Tuesday, 21th of February 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_380091aba30004d0c21f12b5edd46428.setContent(
  html_ff16d823eab738a9a03d7753187ff3ca
);

marker_a4eaea379a2eb3e232f833cc7adc7db2.bindPopup(
  popup_380091aba30004d0c21f12b5edd46428
);

var poly_line_92d51e032559eb08cd9209cea83a6047 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_763dbe23fcec4a2164edc10abe10cd9a = L.marker(
  [12.3178, -1.5285],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_c42d448e5ff456e135ae64ed20f55b91 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_763dbe23fcec4a2164edc10abe10cd9a.setIcon(
  icon_c42d448e5ff456e135ae64ed20f55b91
);

var popup_e091a6f1af3293bd61fd81079631d85b = L.popup({ maxWidth: "100%" });

var html_47da01556b393802da626ae313e5b3fc = $(
  `<div id="html_47da01556b393802da626ae313e5b3fc" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ouagadougou<br>                     <strong>Country:</strong> Burkina Faso<br>                     <strong>Post:</strong> Full bellies!! We were so fortunate to have Miyu and Ines host us in Ouagadougou (Capital of Burkina Faso) for 2 nights. Ines spent 2 hours preparing the most tastey dinner we've had in Africa; gourme<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1329570793791669/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 12.3178<br>                     <strong>Longitude:</strong> -1.5285<br>                     <strong>Date:</strong> Thursday, 23th of February 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_e091a6f1af3293bd61fd81079631d85b.setContent(
  html_47da01556b393802da626ae313e5b3fc
);

marker_763dbe23fcec4a2164edc10abe10cd9a.bindPopup(
  popup_e091a6f1af3293bd61fd81079631d85b
);

var poly_line_84de30768be82259bbb934c58f668f13 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_1b296374f6c35286e99ad736e88560ff = L.marker(
  [12.07375, 0.33459],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_cce3c09d9787342b4a2209905a23d3e5 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_1b296374f6c35286e99ad736e88560ff.setIcon(
  icon_cce3c09d9787342b4a2209905a23d3e5
);

var popup_de823eb5f983a4064c31ee7002ba14e4 = L.popup({ maxWidth: "100%" });

var html_7fe7144e646b2635b7169db2912e4ed9 = $(
  `<div id="html_7fe7144e646b2635b7169db2912e4ed9" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Fada N'gourma<br>                     <strong>Country:</strong> Burkina Faso<br>                     <strong>Post:</strong> Shadow ready to ride. Shadow taught herself to jump up on the motorbikes. This little Min Pin doesn't want to be left behind. No treats were used in the making of this clip. 🐾 🐕  #PillionPooch #MadeTo<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1332533076828774" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 12.07375<br>                     <strong>Longitude:</strong> 0.33459<br>                     <strong>Date:</strong> Friday, 24th of February 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_de823eb5f983a4064c31ee7002ba14e4.setContent(
  html_7fe7144e646b2635b7169db2912e4ed9
);

marker_1b296374f6c35286e99ad736e88560ff.bindPopup(
  popup_de823eb5f983a4064c31ee7002ba14e4
);

var poly_line_b161276235d78c7e8f6b820bd91013bf = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_581f030553af4e5150749047c6581445 = L.marker(
  [9.69153, 1.65943],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_c28d4591962c4a30f8ca225b063503d5 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_581f030553af4e5150749047c6581445.setIcon(
  icon_c28d4591962c4a30f8ca225b063503d5
);

var popup_56eb2d3f542caf2b78d98e78d870676e = L.popup({ maxWidth: "100%" });

var html_81b1357485c3d4c37b07dbd4c8ae9ce8 = $(
  `<div id="html_81b1357485c3d4c37b07dbd4c8ae9ce8" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Djougou<br>                     <strong>Country:</strong> Benin<br>                     <strong>Post:</strong> Shadow ready to ride. Shadow taught herself to jump up on the motorbikes. This little Min Pin doesn't want to be left behind. No treats were used in the making of this clip. 🐾 🐕  #PillionPooch #MadeTo<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1332533076828774" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 9.69153<br>                     <strong>Longitude:</strong> 1.65943<br>                     <strong>Date:</strong> Saturday, 25th of February 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_56eb2d3f542caf2b78d98e78d870676e.setContent(
  html_81b1357485c3d4c37b07dbd4c8ae9ce8
);

marker_581f030553af4e5150749047c6581445.bindPopup(
  popup_56eb2d3f542caf2b78d98e78d870676e
);

var poly_line_7e43243f1cdffdbb367316f72d6f67bc = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_59c984e8cbbd99f1b41bf1e8bec01dee = L.marker(
  [7.22995, 2.43334],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_bf096300ffd2996460e018611ea6ddf4 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_59c984e8cbbd99f1b41bf1e8bec01dee.setIcon(
  icon_bf096300ffd2996460e018611ea6ddf4
);

var popup_5277f0070937f598dd19ae11f517be73 = L.popup({ maxWidth: "100%" });

var html_0ba8eb6965d5b5bbc0fcae20effd0ea8 = $(
  `<div id="html_0ba8eb6965d5b5bbc0fcae20effd0ea8" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Cove<br>                     <strong>Country:</strong> Benin<br>                     <strong>Post:</strong> Shadow ready to ride. Shadow taught herself to jump up on the motorbikes. This little Min Pin doesn't want to be left behind. No treats were used in the making of this clip. 🐾 🐕  #PillionPooch #MadeTo<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1332533076828774" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 7.22995<br>                     <strong>Longitude:</strong> 2.43334<br>                     <strong>Date:</strong> Sunday, 26th of February 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_5277f0070937f598dd19ae11f517be73.setContent(
  html_0ba8eb6965d5b5bbc0fcae20effd0ea8
);

marker_59c984e8cbbd99f1b41bf1e8bec01dee.bindPopup(
  popup_5277f0070937f598dd19ae11f517be73
);

var poly_line_eb96bbd22a346048cd94b8ab965669f3 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_85c81cbdda0c4ef6cf1deb9a072eb2a5 = L.marker(
  [6.5818185, 3.3211348],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_4b7b035bf76c94b86753a3138775ad9c = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_85c81cbdda0c4ef6cf1deb9a072eb2a5.setIcon(
  icon_4b7b035bf76c94b86753a3138775ad9c
);

var popup_84afcbe87060a88af6d41998a4667507 = L.popup({ maxWidth: "100%" });

var html_f6507bd1596bdf84fa0684d06029bfd4 = $(
  `<div id="html_f6507bd1596bdf84fa0684d06029bfd4" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Oshodi<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> Geography lesson. Trying to figure out our route from Nigeria.  Its still 6000km to Victoria Falls! 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #Motorcy<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1347825675299514/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 6.5818185<br>                     <strong>Longitude:</strong> 3.3211348<br>                     <strong>Date:</strong> Monday, 13th of March 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 93.10245<br>                 </div>             </div>`
)[0];
popup_84afcbe87060a88af6d41998a4667507.setContent(
  html_f6507bd1596bdf84fa0684d06029bfd4
);

marker_85c81cbdda0c4ef6cf1deb9a072eb2a5.bindPopup(
  popup_84afcbe87060a88af6d41998a4667507
);

var poly_line_63f22f96429341f707f8732c5c8e2c4d = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_cc5b1e44fc7bb99e95a1159fa7f6583b = L.marker(
  [8.1541, 4.25669],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_300d73c1f9b576511ae5f1b2db011125 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_cc5b1e44fc7bb99e95a1159fa7f6583b.setIcon(
  icon_300d73c1f9b576511ae5f1b2db011125
);

var popup_15066d24595440c6ca9700c0589ffc56 = L.popup({ maxWidth: "100%" });

var html_98f847b4c8ad1eb3bbf3a2a0b6bddf1f = $(
  `<div id="html_98f847b4c8ad1eb3bbf3a2a0b6bddf1f" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ogbomoso<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> Our excursion crew! We've been on a road trip with a Land Cruiser packed with 7 adults. Our Airbnb host, Fola, organised everything - activities, food, drinks, accommodation - and its been a great adv<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1351072928308122/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 8.1541<br>                     <strong>Longitude:</strong> 4.25669<br>                     <strong>Date:</strong> Thursday, 16th of March 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_15066d24595440c6ca9700c0589ffc56.setContent(
  html_98f847b4c8ad1eb3bbf3a2a0b6bddf1f
);

marker_cc5b1e44fc7bb99e95a1159fa7f6583b.bindPopup(
  popup_15066d24595440c6ca9700c0589ffc56
);

var poly_line_aaf505850dd1d8dd0008dc9cd54e04fb = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b1cfc5f94abbb22c41afdc623c52c900 = L.marker(
  [7.46863, 4.89143],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_1a67e29ecda994f786e09580b62f43f5 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b1cfc5f94abbb22c41afdc623c52c900.setIcon(
  icon_1a67e29ecda994f786e09580b62f43f5
);

var popup_8753e680e0b3a7bdc54d52bf51b9f40d = L.popup({ maxWidth: "100%" });

var html_e33bfa28f19f2b201eceb3dd9b5810c8 = $(
  `<div id="html_e33bfa28f19f2b201eceb3dd9b5810c8" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Iperindo<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> Our excursion crew! We've been on a road trip with a Land Cruiser packed with 7 adults. Our Airbnb host, Fola, organised everything - activities, food, drinks, accommodation - and its been a great adv<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1351072928308122/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 7.46863<br>                     <strong>Longitude:</strong> 4.89143<br>                     <strong>Date:</strong> Friday, 17th of March 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_8753e680e0b3a7bdc54d52bf51b9f40d.setContent(
  html_e33bfa28f19f2b201eceb3dd9b5810c8
);

marker_b1cfc5f94abbb22c41afdc623c52c900.bindPopup(
  popup_8753e680e0b3a7bdc54d52bf51b9f40d
);

var poly_line_57d86d151c0c1d03d626f45a4a2c77ea = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_1228719709c0c098ce3b3ee774a5696a = L.marker(
  [6.6228982, 3.3571165],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_eedd8a215d254d6a788a3540ecef0ce4 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_1228719709c0c098ce3b3ee774a5696a.setIcon(
  icon_eedd8a215d254d6a788a3540ecef0ce4
);

var popup_995137797f99da9763ad61eb9e1a7ce4 = L.popup({ maxWidth: "100%" });

var html_dfe3dde4e20ce179ed4b918a33e83d9d = $(
  `<div id="html_dfe3dde4e20ce179ed4b918a33e83d9d" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ikeja<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> Traditional clothes in Nigeria and all West African countries are bright and colourful. Ladies tailor their dresses and skirts to suite their own style and complete the outfit with these gorgeous head<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1353873048028110/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 6.6228982<br>                     <strong>Longitude:</strong> 3.3571165<br>                     <strong>Date:</strong> Sunday, 19th of March 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 98.745094<br>                 </div>             </div>`
)[0];
popup_995137797f99da9763ad61eb9e1a7ce4.setContent(
  html_dfe3dde4e20ce179ed4b918a33e83d9d
);

marker_1228719709c0c098ce3b3ee774a5696a.bindPopup(
  popup_995137797f99da9763ad61eb9e1a7ce4
);

var poly_line_de4692160152bd3dd20739e4b74b2d6c = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_fa8703d51176a2e6114057428e4fcd2b = L.marker(
  [6.72077, 4.87544],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_d28b00a62969fe688fd63a9f15d9c718 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_fa8703d51176a2e6114057428e4fcd2b.setIcon(
  icon_d28b00a62969fe688fd63a9f15d9c718
);

var popup_f3bbc602ee60693b35e825a8fcdc31e4 = L.popup({ maxWidth: "100%" });

var html_2bb6fff60a21ce975e84020a6abf9822 = $(
  `<div id="html_2bb6fff60a21ce975e84020a6abf9822" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ore<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> A 345 year old Tortoise deserves more than one Instagram post Here's some footage of this cutie yawning 🐾 #BMW #BikerDog #MadeToTravel #DogAdoption #DogsOnAdventures #MotorcycleAdventure #AdventureRid<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1355891781159570" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 6.72077<br>                     <strong>Longitude:</strong> 4.87544<br>                     <strong>Date:</strong> Thursday, 23th of March 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_f3bbc602ee60693b35e825a8fcdc31e4.setContent(
  html_2bb6fff60a21ce975e84020a6abf9822
);

marker_fa8703d51176a2e6114057428e4fcd2b.bindPopup(
  popup_f3bbc602ee60693b35e825a8fcdc31e4
);

var poly_line_259282080ae5416d924684cd931f77d1 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_a97cb5f640d85c4221e73c06be3cb663 = L.marker(
  [6.16126, 6.74835],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_ece1e4105bd415f7bb050dafb3aa22e2 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_a97cb5f640d85c4221e73c06be3cb663.setIcon(
  icon_ece1e4105bd415f7bb050dafb3aa22e2
);

var popup_4e45a1dda3f1aadd0e4f0a278f68aa56 = L.popup({ maxWidth: "100%" });

var html_4f2943b2ce7fb447740853642f132ea1 = $(
  `<div id="html_4f2943b2ce7fb447740853642f132ea1" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Asaba<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> We made a new friend in Calabar. This is Fidel, he saw us on the news and then saw us for real in a shopping centre car park and said hello. Spending some time with him and learning about the area and<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1359163437499071/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 6.16126<br>                     <strong>Longitude:</strong> 6.74835<br>                     <strong>Date:</strong> Friday, 24th of March 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_4e45a1dda3f1aadd0e4f0a278f68aa56.setContent(
  html_4f2943b2ce7fb447740853642f132ea1
);

marker_a97cb5f640d85c4221e73c06be3cb663.bindPopup(
  popup_4e45a1dda3f1aadd0e4f0a278f68aa56
);

var poly_line_143baad9959656114ed4f23e22f734b2 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_ea99ffb4d72082d504cb112d7814dfcb = L.marker(
  [4.99355, 8.35313],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_b20a4e925051af77b353bdc2e3e1a30a = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_ea99ffb4d72082d504cb112d7814dfcb.setIcon(
  icon_b20a4e925051af77b353bdc2e3e1a30a
);

var popup_d13a1fbab34cbc1239847a521e285d78 = L.popup({ maxWidth: "100%" });

var html_ff7d875aae3c84839e1a7ca79ad0a05c = $(
  `<div id="html_ff7d875aae3c84839e1a7ca79ad0a05c" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Calabar<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> We made a new friend in Calabar. This is Fidel, he saw us on the news and then saw us for real in a shopping centre car park and said hello. Spending some time with him and learning about the area and<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1359163437499071/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 4.99355<br>                     <strong>Longitude:</strong> 8.35313<br>                     <strong>Date:</strong> Saturday, 25th of March 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_d13a1fbab34cbc1239847a521e285d78.setContent(
  html_ff7d875aae3c84839e1a7ca79ad0a05c
);

marker_ea99ffb4d72082d504cb112d7814dfcb.bindPopup(
  popup_d13a1fbab34cbc1239847a521e285d78
);

var poly_line_ebf1d501d0807fb4964134acd6f37c1f = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_edf262f6fd424deb997ee3f4f5cc076a = L.marker(
  [6.443742, 2.6364933],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_5034f96deef58e2b31fe4d602b79562a = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_edf262f6fd424deb997ee3f4f5cc076a.setIcon(
  icon_5034f96deef58e2b31fe4d602b79562a
);

var popup_fca8735565202ae09cf710de9fccfcbf = L.popup({ maxWidth: "100%" });

var html_6166494ad3ade6f3c0273252f903a3a6 = $(
  `<div id="html_6166494ad3ade6f3c0273252f903a3a6" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Porto-Novo<br>                     <strong>Country:</strong> Benin<br>                     <strong>Post:</strong> We made a new friend in Calabar. This is Fidel, he saw us on the news and then saw us for real in a shopping centre car park and said hello. Spending some time with him and learning about the area and<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1359163437499071/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 6.443742<br>                     <strong>Longitude:</strong> 2.6364933<br>                     <strong>Date:</strong> Sunday, 26th of March 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_fca8735565202ae09cf710de9fccfcbf.setContent(
  html_6166494ad3ade6f3c0273252f903a3a6
);

marker_edf262f6fd424deb997ee3f4f5cc076a.bindPopup(
  popup_fca8735565202ae09cf710de9fccfcbf
);

var poly_line_9b83e2b59fb0cdafd6cfff6d4149284b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_1e2af2457880cb94079e67dc88335b1a = L.marker(
  [4.95104, 8.31387],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_bc5a373261b6fd41e6ab5992e1efe0a4 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_1e2af2457880cb94079e67dc88335b1a.setIcon(
  icon_bc5a373261b6fd41e6ab5992e1efe0a4
);

var popup_28971e369e40ba598f667ec54245e939 = L.popup({ maxWidth: "100%" });

var html_ab1f760c60218085c0fea767d047685c = $(
  `<div id="html_ab1f760c60218085c0fea767d047685c" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Calabar<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> Australia is that way? Good to know, lost my sense of direction 3 years ago but kind of like where its taken me.<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1360078610740887/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 4.95104<br>                     <strong>Longitude:</strong> 8.31387<br>                     <strong>Date:</strong> Tuesday, 28th of March 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_28971e369e40ba598f667ec54245e939.setContent(
  html_ab1f760c60218085c0fea767d047685c
);

marker_1e2af2457880cb94079e67dc88335b1a.bindPopup(
  popup_28971e369e40ba598f667ec54245e939
);

var poly_line_05737f1c2a6b5cac882474a5b4c6335c = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_d36b0daa8284279bfda7240fa15a1763 = L.marker(
  [5.96579, 8.72317],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_8f82b1452cd5a851201ce40c5294f98d = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_d36b0daa8284279bfda7240fa15a1763.setIcon(
  icon_8f82b1452cd5a851201ce40c5294f98d
);

var popup_b87129473db50bd98a1f2672df94631c = L.popup({ maxWidth: "100%" });

var html_8239ddbe841e0fdecea039e22a188f53 = $(
  `<div id="html_8239ddbe841e0fdecea039e22a188f53" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ikom<br>                     <strong>Country:</strong> Nigeria<br>                     <strong>Post:</strong> Breakfast on the go. We wanted a quick, cheap breakfast before our border crossing in to Cameroon so picked up some bread rolls and boiled eggs. The camber of the road prevented Stu from using his sid<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1363263713755710/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 5.96579<br>                     <strong>Longitude:</strong> 8.72317<br>                     <strong>Date:</strong> Wednesday, 29th of March 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_b87129473db50bd98a1f2672df94631c.setContent(
  html_8239ddbe841e0fdecea039e22a188f53
);

marker_d36b0daa8284279bfda7240fa15a1763.bindPopup(
  popup_b87129473db50bd98a1f2672df94631c
);

var poly_line_e35d4ee4b6b6c5e0e63d4d4d3e8e81db = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b2e4f517825c552867362fe5d0e14b81 = L.marker(
  [4.62909, 9.44228],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_0831ba00e7c615c65e36beaee488509f = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b2e4f517825c552867362fe5d0e14b81.setIcon(
  icon_0831ba00e7c615c65e36beaee488509f
);

var popup_c2ec69c6a096d2fac62116fbb0598a30 = L.popup({ maxWidth: "100%" });

var html_f5b1df994c7f805d379447d467c4bf9f = $(
  `<div id="html_f5b1df994c7f805d379447d467c4bf9f" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kumba<br>                     <strong>Country:</strong> Cameroon<br>                     <strong>Post:</strong> Breakfast on the go. We wanted a quick, cheap breakfast before our border crossing in to Cameroon so picked up some bread rolls and boiled eggs. The camber of the road prevented Stu from using his sid<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1363263713755710/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 4.62909<br>                     <strong>Longitude:</strong> 9.44228<br>                     <strong>Date:</strong> Thursday, 30th of March 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_c2ec69c6a096d2fac62116fbb0598a30.setContent(
  html_f5b1df994c7f805d379447d467c4bf9f
);

marker_b2e4f517825c552867362fe5d0e14b81.bindPopup(
  popup_c2ec69c6a096d2fac62116fbb0598a30
);

var poly_line_674c93181219879f27ca3e1900d1d913 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b18ca49de58d0842f820885319bee5a2 = L.marker(
  [3.893211, 11.512039],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_5f4988e6040db74618b1acab34f05d56 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b18ca49de58d0842f820885319bee5a2.setIcon(
  icon_5f4988e6040db74618b1acab34f05d56
);

var popup_fcaef191ec4b79833419305904787518 = L.popup({ maxWidth: "100%" });

var html_9023fa185616ce439ede3079021f728c = $(
  `<div id="html_9023fa185616ce439ede3079021f728c" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Yaounde<br>                     <strong>Country:</strong> Cameroon<br>                     <strong>Post:</strong> Breakfast on the go. We wanted a quick, cheap breakfast before our border crossing in to Cameroon so picked up some bread rolls and boiled eggs. The camber of the road prevented Stu from using his sid<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1363263713755710/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 3.893211<br>                     <strong>Longitude:</strong> 11.512039<br>                     <strong>Date:</strong> Friday, 31th of March 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 97.06042<br>                 </div>             </div>`
)[0];
popup_fcaef191ec4b79833419305904787518.setContent(
  html_9023fa185616ce439ede3079021f728c
);

marker_b18ca49de58d0842f820885319bee5a2.bindPopup(
  popup_fcaef191ec4b79833419305904787518
);

var poly_line_417af9342b60884d5af73ad023fe64a7 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_cde94247fa936bb4178dbb0bfce90783 = L.marker(
  [2.37816, 11.34398],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_47cdc72d61fca9bc8d1dbebc4224218d = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_cde94247fa936bb4178dbb0bfce90783.setIcon(
  icon_47cdc72d61fca9bc8d1dbebc4224218d
);

var popup_cc05aa1204402b82e6b8344ff2ccd578 = L.popup({ maxWidth: "100%" });

var html_0d278bc88f0c27262893dba4c2445bed = $(
  `<div id="html_0d278bc88f0c27262893dba4c2445bed" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ambam<br>                     <strong>Country:</strong> Cameroon<br>                     <strong>Post:</strong> We're in Gabon! Beautiful country with great roads. Spent our first night camping in a small village in the mountains after getting permission from the Chief. Forever grateful for the kind hospitality<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1369683016447113/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 2.37816<br>                     <strong>Longitude:</strong> 11.34398<br>                     <strong>Date:</strong> Wednesday, 5th of April 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_cc05aa1204402b82e6b8344ff2ccd578.setContent(
  html_0d278bc88f0c27262893dba4c2445bed
);

marker_cde94247fa936bb4178dbb0bfce90783.bindPopup(
  popup_cc05aa1204402b82e6b8344ff2ccd578
);

var poly_line_285c2dae83b3fd97601638562f5fed7d = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b47f6f69bc7077be5008f949593b6c14 = L.marker(
  [0.0892, 11.08074],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_8dd20f523b981013ff675f4cbd1a25c8 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b47f6f69bc7077be5008f949593b6c14.setIcon(
  icon_8dd20f523b981013ff675f4cbd1a25c8
);

var popup_effd788c7b986448895dc80da09d4b77 = L.popup({ maxWidth: "100%" });

var html_d31efe93da28aaeda7c17f211cbe6796 = $(
  `<div id="html_d31efe93da28aaeda7c17f211cbe6796" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ndjole<br>                     <strong>Country:</strong> Gabon<br>                     <strong>Post:</strong> We're in Gabon! Beautiful country with great roads. Spent our first night camping in a small village in the mountains after getting permission from the Chief. Forever grateful for the kind hospitality<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1369683016447113/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 0.0892<br>                     <strong>Longitude:</strong> 11.08074<br>                     <strong>Date:</strong> Thursday, 6th of April 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_effd788c7b986448895dc80da09d4b77.setContent(
  html_d31efe93da28aaeda7c17f211cbe6796
);

marker_b47f6f69bc7077be5008f949593b6c14.bindPopup(
  popup_effd788c7b986448895dc80da09d4b77
);

var poly_line_daa1b3df5a868b436ade784169d6a051 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_baa6ede69bd5eca219c2106e900ecb70 = L.marker(
  [0.378, 9.45472],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_8a5218fcf99a255415647b2a14694a2d = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_baa6ede69bd5eca219c2106e900ecb70.setIcon(
  icon_8a5218fcf99a255415647b2a14694a2d
);

var popup_9a23a3331dadc07190608b680705a216 = L.popup({ maxWidth: "100%" });

var html_308086f71c077596ab6fae1907283110 = $(
  `<div id="html_308086f71c077596ab6fae1907283110" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Libreville<br>                     <strong>Country:</strong> Gabon<br>                     <strong>Post:</strong> Another check point?! Don't they know who I am?! 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsO<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1372087729539975/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 0.378<br>                     <strong>Longitude:</strong> 9.45472<br>                     <strong>Date:</strong> Friday, 7th of April 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_9a23a3331dadc07190608b680705a216.setContent(
  html_308086f71c077596ab6fae1907283110
);

marker_baa6ede69bd5eca219c2106e900ecb70.bindPopup(
  popup_9a23a3331dadc07190608b680705a216
);

var poly_line_f73dad583602d655d787b764c0ad9433 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_0268b63c7bd8e94d4626bd4a4cd2bb4f = L.marker(
  [-2.41679, 11.44713],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_fff7859269d6298a7918f95edf56297f = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_0268b63c7bd8e94d4626bd4a4cd2bb4f.setIcon(
  icon_fff7859269d6298a7918f95edf56297f
);

var popup_0f358a517fd5716ee516d77fe98e0e0d = L.popup({ maxWidth: "100%" });

var html_410232cddc45a6151187415c54af94ee = $(
  `<div id="html_410232cddc45a6151187415c54af94ee" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ndende<br>                     <strong>Country:</strong> Gabon<br>                     <strong>Post:</strong> The Congo road wasn't all bad and to be fair we've enjoyed sealed roads through most of Africa so far. But when it was nice like this we got to enjoy the stunning scenery. We were rushing to get to Po<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1378965288852219/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -2.41679<br>                     <strong>Longitude:</strong> 11.44713<br>                     <strong>Date:</strong> Thursday, 13th of April 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_0f358a517fd5716ee516d77fe98e0e0d.setContent(
  html_410232cddc45a6151187415c54af94ee
);

marker_0268b63c7bd8e94d4626bd4a4cd2bb4f.bindPopup(
  popup_0f358a517fd5716ee516d77fe98e0e0d
);

var poly_line_31e4d08b9da767234be446963df51fd6 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_313500a0f726e1da7c0c6ef468a4f9de = L.marker(
  [-3.48637, 12.32368],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_4979cc8c1f9e10e2a42a79d16d2e3263 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_313500a0f726e1da7c0c6ef468a4f9de.setIcon(
  icon_4979cc8c1f9e10e2a42a79d16d2e3263
);

var popup_ea36b7cd82a683cb1d17566dcba6c4ad = L.popup({ maxWidth: "100%" });

var html_1faaa4c2e3931809ffa4bb6215781d23 = $(
  `<div id="html_1faaa4c2e3931809ffa4bb6215781d23" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mossendjo<br>                     <strong>Country:</strong> Congo<br>                     <strong>Post:</strong> The Congo road wasn't all bad and to be fair we've enjoyed sealed roads through most of Africa so far. But when it was nice like this we got to enjoy the stunning scenery. We were rushing to get to Po<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1378965288852219/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -3.48637<br>                     <strong>Longitude:</strong> 12.32368<br>                     <strong>Date:</strong> Friday, 14th of April 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_ea36b7cd82a683cb1d17566dcba6c4ad.setContent(
  html_1faaa4c2e3931809ffa4bb6215781d23
);

marker_313500a0f726e1da7c0c6ef468a4f9de.bindPopup(
  popup_ea36b7cd82a683cb1d17566dcba6c4ad
);

var poly_line_4a9052dc44786977f093cd6524780738 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_44e0d1227ac40c24ad8f7007ca7ddd7b = L.marker(
  [-4.83415, 11.88315],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_985e749da2583d11937bb2458216a968 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_44e0d1227ac40c24ad8f7007ca7ddd7b.setIcon(
  icon_985e749da2583d11937bb2458216a968
);

var popup_39bf48c9cf49fd555943a96c5f3a5816 = L.popup({ maxWidth: "100%" });

var html_8940fb8f126da68764d53bb2161244f9 = $(
  `<div id="html_8940fb8f126da68764d53bb2161244f9" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Pointe-Noire<br>                     <strong>Country:</strong> Congo<br>                     <strong>Post:</strong> ANZAC Day in Cabinda, Angola. I think we are the only Australians here but we got up and had our own Dawn Service on the balcony of our hotel facing the ocean. Stu wore his medals and we visited an An<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1392106914204723/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -4.83415<br>                     <strong>Longitude:</strong> 11.88315<br>                     <strong>Date:</strong> Monday, 24th of April 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_39bf48c9cf49fd555943a96c5f3a5816.setContent(
  html_8940fb8f126da68764d53bb2161244f9
);

marker_44e0d1227ac40c24ad8f7007ca7ddd7b.bindPopup(
  popup_39bf48c9cf49fd555943a96c5f3a5816
);

var poly_line_1d1b523b27210b0f92df00c0b18e1c63 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_3fb48e6793fa2f48e8a470ec3553126d = L.marker(
  [-10.74034, 14.98117],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_7b3d0605cb61dd822f128307ca71927b = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_3fb48e6793fa2f48e8a470ec3553126d.setIcon(
  icon_7b3d0605cb61dd822f128307ca71927b
);

var popup_33e5593bcda44e351ed23a527f75b1bf = L.popup({ maxWidth: "100%" });

var html_9da682a8efefb1c07c0aa50551b4e54d = $(
  `<div id="html_9da682a8efefb1c07c0aa50551b4e54d" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Quibala<br>                     <strong>Country:</strong> Angola<br>                     <strong>Post:</strong> Traveling in convoy through Angola with @bonobosonroute, a Spanish couple we met in Pointe Noire, who finish their current 4x4 adventure in South Africa. Pulling in to our campsite last night in the d<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1395076440574437/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -10.74034<br>                     <strong>Longitude:</strong> 14.98117<br>                     <strong>Date:</strong> Saturday, 29th of April 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_33e5593bcda44e351ed23a527f75b1bf.setContent(
  html_9da682a8efefb1c07c0aa50551b4e54d
);

marker_3fb48e6793fa2f48e8a470ec3553126d.bindPopup(
  popup_33e5593bcda44e351ed23a527f75b1bf
);

var poly_line_e9399f96a91283351acf0a3ed486226f = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_384ce654c97def7a13a619f00571c57f = L.marker(
  [-12.62257, 13.34107],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_3ed8734f309821df9ebf56fefca32023 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_384ce654c97def7a13a619f00571c57f.setIcon(
  icon_3ed8734f309821df9ebf56fefca32023
);

var popup_dc6c63900ca450ee2ae5c9206b3d7643 = L.popup({ maxWidth: "100%" });

var html_96358f9ec191ff8ac76f30e20f4360ff = $(
  `<div id="html_96358f9ec191ff8ac76f30e20f4360ff" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Benguela<br>                     <strong>Country:</strong> Angola<br>                     <strong>Post:</strong> Check out the switch back in the background. This is Serra da Leba pass in the South of Angola. We got a photo from the viewing point before riding it. The mountains, valley, rocks and vegetation are <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1396423677106380/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -12.62257<br>                     <strong>Longitude:</strong> 13.34107<br>                     <strong>Date:</strong> Sunday, 30th of April 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_dc6c63900ca450ee2ae5c9206b3d7643.setContent(
  html_96358f9ec191ff8ac76f30e20f4360ff
);

marker_384ce654c97def7a13a619f00571c57f.bindPopup(
  popup_dc6c63900ca450ee2ae5c9206b3d7643
);

var poly_line_b70944a625a8696802871d811e08a643 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_e232cd15bf14c037886e49fbb04b8cae = L.marker(
  [-14.92365, 13.47621],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_a3aa3e30f55a049a14b8b22cbd8809bd = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_e232cd15bf14c037886e49fbb04b8cae.setIcon(
  icon_a3aa3e30f55a049a14b8b22cbd8809bd
);

var popup_0e311834575216b0f16fd93703700ad6 = L.popup({ maxWidth: "100%" });

var html_9cf33b2db0deb61308034b95e09d8e76 = $(
  `<div id="html_9cf33b2db0deb61308034b95e09d8e76" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Lubango<br>                     <strong>Country:</strong> Angola<br>                     <strong>Post:</strong> An all too familiar scene. Janells motorbike in pieces on the side of the road because it wants to move in to retirement. Today, engine cuts out with the overheating indicator on. Oil seems okay, plen<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1396953523720062/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -14.92365<br>                     <strong>Longitude:</strong> 13.47621<br>                     <strong>Date:</strong> Monday, 1th of May 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_0e311834575216b0f16fd93703700ad6.setContent(
  html_9cf33b2db0deb61308034b95e09d8e76
);

marker_e232cd15bf14c037886e49fbb04b8cae.bindPopup(
  popup_0e311834575216b0f16fd93703700ad6
);

var poly_line_7f38b9f8b6c2838f1fdd7d5e800fdc8f = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b1485f83b0c44db4a7caafe8b5a4c958 = L.marker(
  [-17.21175, 14.67346],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_8da0bd86e33a74025ce9cd77c35c7de9 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b1485f83b0c44db4a7caafe8b5a4c958.setIcon(
  icon_8da0bd86e33a74025ce9cd77c35c7de9
);

var popup_8c0664df14e0a411d20eda7de3bfd3b1 = L.popup({ maxWidth: "100%" });

var html_5f83634b07e39338bbba645f976fed5e = $(
  `<div id="html_5f83634b07e39338bbba645f976fed5e" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Outapi<br>                     <strong>Country:</strong> Namibia<br>                     <strong>Post:</strong> Lubango, we will miss you A really nice area to visit but today we ride to Namibia! Yes, Janells motorbike rides again. Uigher and his friends worked very late last night putting the bike back togethe<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1401729513242463" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -17.21175<br>                     <strong>Longitude:</strong> 14.67346<br>                     <strong>Date:</strong> Sunday, 7th of May 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_8c0664df14e0a411d20eda7de3bfd3b1.setContent(
  html_5f83634b07e39338bbba645f976fed5e
);

marker_b1485f83b0c44db4a7caafe8b5a4c958.bindPopup(
  popup_8c0664df14e0a411d20eda7de3bfd3b1
);

var poly_line_6e838d693c8b1602a6e0e23ac4c4db8b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_76709f0ec6a3a94bf4c1e2ae219e8c17 = L.marker(
  [-18.69547, 13.74345],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_7e04a0600910dafd37beeeb12812718f = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_76709f0ec6a3a94bf4c1e2ae219e8c17.setIcon(
  icon_7e04a0600910dafd37beeeb12812718f
);

var popup_2bcfc0e1f39680acb9a01e0cf513d650 = L.popup({ maxWidth: "100%" });

var html_a6a644f5c35a6825d8aa2ca666571aec = $(
  `<div id="html_a6a644f5c35a6825d8aa2ca666571aec" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Opuwo<br>                     <strong>Country:</strong> Namibia<br>                     <strong>Post:</strong> Welcome to Namibia 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoption #Adop<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1404117473003667/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -18.69547<br>                     <strong>Longitude:</strong> 13.74345<br>                     <strong>Date:</strong> Monday, 8th of May 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_2bcfc0e1f39680acb9a01e0cf513d650.setContent(
  html_a6a644f5c35a6825d8aa2ca666571aec
);

marker_76709f0ec6a3a94bf4c1e2ae219e8c17.bindPopup(
  popup_2bcfc0e1f39680acb9a01e0cf513d650
);

var poly_line_a756e3d9f12bfe9a657e98e32cc085ad = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_3b70d8265feb266b9ceae47370393b25 = L.marker(
  [-19.9243, 13.98478],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_805eb6e3b88f41e89b62f0bd663be97c = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_3b70d8265feb266b9ceae47370393b25.setIcon(
  icon_805eb6e3b88f41e89b62f0bd663be97c
);

var popup_d7907cf914c80510268f0186ff329f6f = L.popup({ maxWidth: "100%" });

var html_34007241179ab19eb6c9a2c9aa1d85d9 = $(
  `<div id="html_34007241179ab19eb6c9a2c9aa1d85d9" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Khorixas<br>                     <strong>Country:</strong> Namibia<br>                     <strong>Post:</strong> Welcome to Namibia 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoption #Adop<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1404117473003667/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -19.9243<br>                     <strong>Longitude:</strong> 13.98478<br>                     <strong>Date:</strong> Tuesday, 9th of May 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_d7907cf914c80510268f0186ff329f6f.setContent(
  html_34007241179ab19eb6c9a2c9aa1d85d9
);

marker_3b70d8265feb266b9ceae47370393b25.bindPopup(
  popup_d7907cf914c80510268f0186ff329f6f
);

var poly_line_a37889abf3e0f2545bb257b6168283bd = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_f26670d1964e981a414e103ad1f77d7e = L.marker(
  [-21.21834, 14.86787],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_ebe1c98edb4be5f6b2871ce593c61ff2 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_f26670d1964e981a414e103ad1f77d7e.setIcon(
  icon_ebe1c98edb4be5f6b2871ce593c61ff2
);

var popup_a8838de67ec89db4c346230ded1ec034 = L.popup({ maxWidth: "100%" });

var html_659fd0c9634372841cd851bdbc08913f = $(
  `<div id="html_659fd0c9634372841cd851bdbc08913f" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Khorixas<br>                     <strong>Country:</strong> Namibia<br>                     <strong>Post:</strong> On the lookout for elephants. Apparently in the dry season it should be easier to see elephants because they move closer to the roads. We've been to a few watering holes but no luck so far. 🐾 🐕  #Pill<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1405614452853969/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -21.21834<br>                     <strong>Longitude:</strong> 14.86787<br>                     <strong>Date:</strong> Wednesday, 10th of May 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_a8838de67ec89db4c346230ded1ec034.setContent(
  html_659fd0c9634372841cd851bdbc08913f
);

marker_f26670d1964e981a414e103ad1f77d7e.bindPopup(
  popup_a8838de67ec89db4c346230ded1ec034
);

var poly_line_a074725890496002445d8883d4f99032 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_c6caf11b117c103b376db62c856d1062 = L.marker(
  [-22.6566275, 14.5493917],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_9cccedb19f7a273d80c4e1894f4dc238 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_c6caf11b117c103b376db62c856d1062.setIcon(
  icon_9cccedb19f7a273d80c4e1894f4dc238
);

var popup_a0750c386eaf33f50ad868d496e37c2f = L.popup({ maxWidth: "100%" });

var html_9c9bfbc51fce92cedee61ae4732a87f4 = $(
  `<div id="html_9c9bfbc51fce92cedee61ae4732a87f4" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Swakopmund<br>                     <strong>Country:</strong> Namibia<br>                     <strong>Post:</strong> On the lookout for elephants. Apparently in the dry season it should be easier to see elephants because they move closer to the roads. We've been to a few watering holes but no luck so far. 🐾 🐕  #Pill<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1405614452853969/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -22.6566275<br>                     <strong>Longitude:</strong> 14.5493917<br>                     <strong>Date:</strong> Thursday, 11th of May 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.403984<br>                 </div>             </div>`
)[0];
popup_a0750c386eaf33f50ad868d496e37c2f.setContent(
  html_9c9bfbc51fce92cedee61ae4732a87f4
);

marker_c6caf11b117c103b376db62c856d1062.bindPopup(
  popup_a0750c386eaf33f50ad868d496e37c2f
);

var poly_line_aa2e78a46d6e587b4c8b97c72e280735 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_02cc93077c3ac1c4cd1c1c70b9a47c98 = L.marker(
  [-22.619111, 17.094296],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_91cee4f448221243d005546dc20d023b = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_02cc93077c3ac1c4cd1c1c70b9a47c98.setIcon(
  icon_91cee4f448221243d005546dc20d023b
);

var popup_850b2bd569d16aa3eb1461ba6f84f791 = L.popup({ maxWidth: "100%" });

var html_0bbc179bfc6650e6758d92ed66313a70 = $(
  `<div id="html_0bbc179bfc6650e6758d92ed66313a70" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Windhoek<br>                     <strong>Country:</strong> Namibia<br>                     <strong>Post:</strong> Janells motorbike has taken a liking to being ferried around on other vehicles. Lazy! Broke down again today 50km in to a 350km ride to Windhoek, the capital of Namibia. We know there is a BMW mechani<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1407538072661607/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -22.619111<br>                     <strong>Longitude:</strong> 17.094296<br>                     <strong>Date:</strong> Sunday, 14th of May 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.9868<br>                 </div>             </div>`
)[0];
popup_850b2bd569d16aa3eb1461ba6f84f791.setContent(
  html_0bbc179bfc6650e6758d92ed66313a70
);

marker_02cc93077c3ac1c4cd1c1c70b9a47c98.bindPopup(
  popup_850b2bd569d16aa3eb1461ba6f84f791
);

var poly_line_3a8c8a86be1adb8308cb69ed59111669 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_bc91813fb544e42c4361f2d1aaaf95d0 = L.marker(
  [-27.36668, 18.54707],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_75339976bc7ebc622c2320f0a70dd571 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_bc91813fb544e42c4361f2d1aaaf95d0.setIcon(
  icon_75339976bc7ebc622c2320f0a70dd571
);

var popup_acd20c6c4dba3333ae5616a6c85f7024 = L.popup({ maxWidth: "100%" });

var html_17a0bbd4329eac599ff00d2d45321772 = $(
  `<div id="html_17a0bbd4329eac599ff00d2d45321772" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Karasburg<br>                     <strong>Country:</strong> Namibia<br>                     <strong>Post:</strong> If we can't fix Janells bike we're coming back for this ute. 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #Pupp<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1414146142000800/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -27.36668<br>                     <strong>Longitude:</strong> 18.54707<br>                     <strong>Date:</strong> Sunday, 21th of May 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_acd20c6c4dba3333ae5616a6c85f7024.setContent(
  html_17a0bbd4329eac599ff00d2d45321772
);

marker_bc91813fb544e42c4361f2d1aaaf95d0.bindPopup(
  popup_acd20c6c4dba3333ae5616a6c85f7024
);

var poly_line_f9268c0e2c908a09f66daeed69e38d62 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_4d7bae728c6502708ffa07fe4abf5dd0 = L.marker(
  [-29.6862, 17.88821],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_9c4f027e4a6f8fe292a915402b0e13e1 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_4d7bae728c6502708ffa07fe4abf5dd0.setIcon(
  icon_9c4f027e4a6f8fe292a915402b0e13e1
);

var popup_d4e1521f664332ead95a80312222dfda = L.popup({ maxWidth: "100%" });

var html_b67a6c97f855b247f4ca5bd2926f1b66 = $(
  `<div id="html_b67a6c97f855b247f4ca5bd2926f1b66" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Springbok<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Moving South it's getting a bit chilly. The girls need their jumpers on, even at midday for a coffee break 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1418474911567923/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -29.6862<br>                     <strong>Longitude:</strong> 17.88821<br>                     <strong>Date:</strong> Thursday, 25th of May 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_d4e1521f664332ead95a80312222dfda.setContent(
  html_b67a6c97f855b247f4ca5bd2926f1b66
);

marker_4d7bae728c6502708ffa07fe4abf5dd0.bindPopup(
  popup_d4e1521f664332ead95a80312222dfda
);

var poly_line_719acc888506df3fc82adc6fa94891d7 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_f874c5b24b1edb73ca00979798f662e5 = L.marker(
  [-27.4453, 23.48806],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_184464b1b5f90b16fc552d394ce056a5 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_f874c5b24b1edb73ca00979798f662e5.setIcon(
  icon_184464b1b5f90b16fc552d394ce056a5
);

var popup_e7391a640e04d36c959f06f05e72bdf5 = L.popup({ maxWidth: "100%" });

var html_1fc57a4000e5c9801a5e1b8bce800637 = $(
  `<div id="html_1fc57a4000e5c9801a5e1b8bce800637" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kuruman<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Moving South it's getting a bit chilly. The girls need their jumpers on, even at midday for a coffee break 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1418474911567923/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -27.4453<br>                     <strong>Longitude:</strong> 23.48806<br>                     <strong>Date:</strong> Friday, 26th of May 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_e7391a640e04d36c959f06f05e72bdf5.setContent(
  html_1fc57a4000e5c9801a5e1b8bce800637
);

marker_f874c5b24b1edb73ca00979798f662e5.bindPopup(
  popup_e7391a640e04d36c959f06f05e72bdf5
);

var poly_line_f15fda341270fa3f2533f437e74d971e = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_87cf44849ea0953bdd198e55a67b118d = L.marker(
  [-25.93744, 27.97628],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_7ec1cf1647316a4efc8772bcce102df1 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_87cf44849ea0953bdd198e55a67b118d.setIcon(
  icon_7ec1cf1647316a4efc8772bcce102df1
);

var popup_0d929c9124580d3e05dcebfef1fa54d2 = L.popup({ maxWidth: "100%" });

var html_43287bdb428bd905b853c3b202266c65 = $(
  `<div id="html_43287bdb428bd905b853c3b202266c65" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Diepsloot<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> We gave a presentation last night to the BMW Motorcycle Club Pretoria. It was a fun night, the girls got lots of attention parked up inside the Bavarian Motorcycles Shop, and we appreciated​ the oppor<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1425930944155653/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -25.93744<br>                     <strong>Longitude:</strong> 27.97628<br>                     <strong>Date:</strong> Saturday, 3th of June 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_0d929c9124580d3e05dcebfef1fa54d2.setContent(
  html_43287bdb428bd905b853c3b202266c65
);

marker_87cf44849ea0953bdd198e55a67b118d.bindPopup(
  popup_0d929c9124580d3e05dcebfef1fa54d2
);

var poly_line_e1db309fa501b5ad410d8bf6bde8d0a4 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_0561f9a3e6be165c51259b046824093c = L.marker(
  [-26.61093, 27.28995],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_fa9fb05f642a646cce06005965e30521 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_0561f9a3e6be165c51259b046824093c.setIcon(
  icon_fa9fb05f642a646cce06005965e30521
);

var popup_1085e168415fb6f388a6d532ee90f60b = L.popup({ maxWidth: "100%" });

var html_397861df6ca5a26db4dd6d9c9b53d651 = $(
  `<div id="html_397861df6ca5a26db4dd6d9c9b53d651" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Potchefstroom<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Our good friend EH Alberts and his rescue dog Chaco riding. Love these guys.<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1427656273983120/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -26.61093<br>                     <strong>Longitude:</strong> 27.28995<br>                     <strong>Date:</strong> Sunday, 4th of June 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_1085e168415fb6f388a6d532ee90f60b.setContent(
  html_397861df6ca5a26db4dd6d9c9b53d651
);

marker_0561f9a3e6be165c51259b046824093c.bindPopup(
  popup_1085e168415fb6f388a6d532ee90f60b
);

var poly_line_110be72fd1c26a315581bdfb311c166c = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_ac5e1f1841076f1df7d7d62626bf1acf = L.marker(
  [-28.73978, 24.75205],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_c16d6d9b1d5cb0524b4d643fa9d78c7c = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_ac5e1f1841076f1df7d7d62626bf1acf.setIcon(
  icon_c16d6d9b1d5cb0524b4d643fa9d78c7c
);

var popup_ea5d2640d84b3c87d55b4bbf779e738d = L.popup({ maxWidth: "100%" });

var html_8bc1ccc83cb0d2f8adec29ee16e1e636 = $(
  `<div id="html_8bc1ccc83cb0d2f8adec29ee16e1e636" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kimberley<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> #Spooning in the tent. They can't deny the photographic evidence 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1429870140428400/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -28.73978<br>                     <strong>Longitude:</strong> 24.75205<br>                     <strong>Date:</strong> Monday, 5th of June 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_ea5d2640d84b3c87d55b4bbf779e738d.setContent(
  html_8bc1ccc83cb0d2f8adec29ee16e1e636
);

marker_ac5e1f1841076f1df7d7d62626bf1acf.bindPopup(
  popup_ea5d2640d84b3c87d55b4bbf779e738d
);

var poly_line_e7cb82e2399f4b1448e9754b58e4b5ae = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_c0bb7d58d52ba34d1c0c2473a2d91df1 = L.marker(
  [-30.58723, 23.50636],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_b0349220b457a6b50853505a97e0472a = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_c0bb7d58d52ba34d1c0c2473a2d91df1.setIcon(
  icon_b0349220b457a6b50853505a97e0472a
);

var popup_330550a08b82a59bfaf443c643ab3256 = L.popup({ maxWidth: "100%" });

var html_08a52a85800e82e97649f2b32c2cb760 = $(
  `<div id="html_08a52a85800e82e97649f2b32c2cb760" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> De Aar<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> #Spooning in the tent. They can't deny the photographic evidence 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1429870140428400/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -30.58723<br>                     <strong>Longitude:</strong> 23.50636<br>                     <strong>Date:</strong> Tuesday, 6th of June 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_330550a08b82a59bfaf443c643ab3256.setContent(
  html_08a52a85800e82e97649f2b32c2cb760
);

marker_c0bb7d58d52ba34d1c0c2473a2d91df1.bindPopup(
  popup_330550a08b82a59bfaf443c643ab3256
);

var poly_line_c99444c32f8f4a4cb4ce5f1207267a3b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_fb3613a048faf41431b042058270dd2e = L.marker(
  [-31.4624788, 19.800442],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_c7f500f89464b4d71f2c78887f3a87b6 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_fb3613a048faf41431b042058270dd2e.setIcon(
  icon_c7f500f89464b4d71f2c78887f3a87b6
);

var popup_c4ed6e0cf66ce2142a1b840715a2ade0 = L.popup({ maxWidth: "100%" });

var html_d80afb3e9ef8ab34ffc83d373f587c2a = $(
  `<div id="html_d80afb3e9ef8ab34ffc83d373f587c2a" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Calvinia<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Brrrrrrrr it snowed last night outside our B&B. Another rough night of storms, so happy to be warm and dry inside with the girls snuggled up. 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRide<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1431605710254843/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -31.4624788<br>                     <strong>Longitude:</strong> 19.800442<br>                     <strong>Date:</strong> Thursday, 8th of June 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.99689<br>                 </div>             </div>`
)[0];
popup_c4ed6e0cf66ce2142a1b840715a2ade0.setContent(
  html_d80afb3e9ef8ab34ffc83d373f587c2a
);

marker_fb3613a048faf41431b042058270dd2e.bindPopup(
  popup_c4ed6e0cf66ce2142a1b840715a2ade0
);

var poly_line_89053dc6d593cd189ac3b7a9b79a4f1d = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_e4c5d7208a6d6f01a664857b1a2800ce = L.marker(
  [-33.0493581, 18.0649076],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_244b23b5ce221ea16ceb4aa4c85d0a37 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_e4c5d7208a6d6f01a664857b1a2800ce.setIcon(
  icon_244b23b5ce221ea16ceb4aa4c85d0a37
);

var popup_c56f1220922f2d2093255a2c848af3ef = L.popup({ maxWidth: "100%" });

var html_e4239153b4db7d0c2e7f2cc50dcd3a61 = $(
  `<div id="html_e4239153b4db7d0c2e7f2cc50dcd3a61" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Saldanha<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> We're adopting the Plant family in Langebaan. We just spent 2 nights with these guys thanks to a message sent by Ronel 3 years ago when we just set off!!! We were in animal heaven there was soooo much<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1434700213278726/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -33.0493581<br>                     <strong>Longitude:</strong> 18.0649076<br>                     <strong>Date:</strong> Saturday, 10th of June 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 96.529594<br>                 </div>             </div>`
)[0];
popup_c56f1220922f2d2093255a2c848af3ef.setContent(
  html_e4239153b4db7d0c2e7f2cc50dcd3a61
);

marker_e4c5d7208a6d6f01a664857b1a2800ce.bindPopup(
  popup_c56f1220922f2d2093255a2c848af3ef
);

var poly_line_1a26cf94a702116f0c57f64f226e99a5 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_bd1cd0c1520e65ca779f13577f8284d6 = L.marker(
  [-33.88377, 18.65462],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_7306af2cbc5e3980194c194b76c31477 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_bd1cd0c1520e65ca779f13577f8284d6.setIcon(
  icon_7306af2cbc5e3980194c194b76c31477
);

var popup_d69544f5c881420eb12e14db0ae9cb75 = L.popup({ maxWidth: "100%" });

var html_60700026bc49904822491fb683673ed1 = $(
  `<div id="html_60700026bc49904822491fb683673ed1" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kraaifontein<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> We sold our 1st Pillion Pooch!! Our Kickstarter Campaign started today and runs for 40 days. If you want one too visit our website. 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnA<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1435711683177579/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -33.88377<br>                     <strong>Longitude:</strong> 18.65462<br>                     <strong>Date:</strong> Monday, 12th of June 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 97.3526<br>                 </div>             </div>`
)[0];
popup_d69544f5c881420eb12e14db0ae9cb75.setContent(
  html_60700026bc49904822491fb683673ed1
);

marker_bd1cd0c1520e65ca779f13577f8284d6.bindPopup(
  popup_d69544f5c881420eb12e14db0ae9cb75
);

var poly_line_d76b22b349566ebb6b4b60964febb500 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_ac6178a72e08336e0da39197fffc0412 = L.marker(
  [-33.52701, 21.74158],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_dbdb8e6abcc26e53829acabf6af4db1f = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_ac6178a72e08336e0da39197fffc0412.setIcon(
  icon_dbdb8e6abcc26e53829acabf6af4db1f
);

var popup_fc55b61ee0280626331b2c6faf47a77d = L.popup({ maxWidth: "100%" });

var html_0b2da7fbf7cebd935f505fff7136505e = $(
  `<div id="html_0b2da7fbf7cebd935f505fff7136505e" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Prince Albert<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Today just got better and better. We popped in to Ronnie's Sex Shop on Route 62 for a shot of tequila before the sun went down. Mum was a good sport and downed it after admitting cough medicine tasted<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1442318409183573/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -33.52701<br>                     <strong>Longitude:</strong> 21.74158<br>                     <strong>Date:</strong> Tuesday, 20th of June 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_fc55b61ee0280626331b2c6faf47a77d.setContent(
  html_0b2da7fbf7cebd935f505fff7136505e
);

marker_ac6178a72e08336e0da39197fffc0412.bindPopup(
  popup_fc55b61ee0280626331b2c6faf47a77d
);

var poly_line_25d96fbd365dd3e32a934b31bcd10918 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_919b8ecc55a8a2a803c6a5625f297e1c = L.marker(
  [-34.2109619, 24.835235],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_7d1c6e05fb95ecb0ea28b5f49c167f96 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_919b8ecc55a8a2a803c6a5625f297e1c.setIcon(
  icon_7d1c6e05fb95ecb0ea28b5f49c167f96
);

var popup_70bbde32fa324b116ea7276ff9985e65 = L.popup({ maxWidth: "100%" });

var html_34740409587c4f9898a83eddabfb734e = $(
  `<div id="html_34740409587c4f9898a83eddabfb734e" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Jeffrey's Bay<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Today just got better and better. We popped in to Ronnie's Sex Shop on Route 62 for a shot of tequila before the sun went down. Mum was a good sport and downed it after admitting cough medicine tasted<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1442318409183573/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -34.2109619<br>                     <strong>Longitude:</strong> 24.835235<br>                     <strong>Date:</strong> Wednesday, 21th of June 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 98.94664<br>                 </div>             </div>`
)[0];
popup_70bbde32fa324b116ea7276ff9985e65.setContent(
  html_34740409587c4f9898a83eddabfb734e
);

marker_919b8ecc55a8a2a803c6a5625f297e1c.bindPopup(
  popup_70bbde32fa324b116ea7276ff9985e65
);

var poly_line_4be609956a7e1d040d6ef01c2d24679d = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_cd8345c24b8c38ae3c0a87263f6ebdb7 = L.marker(
  [-32.8668053, 28.0638896],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_230090d6dfea67af454df76fd99a2bd1 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_cd8345c24b8c38ae3c0a87263f6ebdb7.setIcon(
  icon_230090d6dfea67af454df76fd99a2bd1
);

var popup_87bbc759fae475023ec221272e43833c = L.popup({ maxWidth: "100%" });

var html_a205705892b0632fb2c7de64cd448282 = $(
  `<div id="html_a205705892b0632fb2c7de64cd448282" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> East London<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Coming through the mountains. It's cold so the girls are zipped away in their Pillion Pooch but not missing out on the views 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventur<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1447032435378837/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -32.8668053<br>                     <strong>Longitude:</strong> 28.0638896<br>                     <strong>Date:</strong> Friday, 23th of June 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_87bbc759fae475023ec221272e43833c.setContent(
  html_a205705892b0632fb2c7de64cd448282
);

marker_cd8345c24b8c38ae3c0a87263f6ebdb7.bindPopup(
  popup_87bbc759fae475023ec221272e43833c
);

var poly_line_13e3c55229e462d10f04ba893c5c8e44 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_fb06a5dec9c04face4bd0204bf8e3150 = L.marker(
  [-31.61665, 29.54288],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_da96925d4eb101a5cf7b6a5b8484996e = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_fb06a5dec9c04face4bd0204bf8e3150.setIcon(
  icon_da96925d4eb101a5cf7b6a5b8484996e
);

var popup_012680a7f1900f986e84f77e8ce048fb = L.popup({ maxWidth: "100%" });

var html_d2ebd7cc88a35d85971c0d4d1afb3860 = $(
  `<div id="html_d2ebd7cc88a35d85971c0d4d1afb3860" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Port Saint John's<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Coming through the mountains. It's cold so the girls are zipped away in their Pillion Pooch but not missing out on the views 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventur<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1447032435378837/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -31.61665<br>                     <strong>Longitude:</strong> 29.54288<br>                     <strong>Date:</strong> Sunday, 25th of June 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_012680a7f1900f986e84f77e8ce048fb.setContent(
  html_d2ebd7cc88a35d85971c0d4d1afb3860
);

marker_fb06a5dec9c04face4bd0204bf8e3150.bindPopup(
  popup_012680a7f1900f986e84f77e8ce048fb
);

var poly_line_098e773fd4514eb73201a8313f66e54d = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_fa6167069235e90735034a6c0401fff0 = L.marker(
  [-29.8289571, 31.0303869],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_525597cef1e7495a82e5f66c7ba60660 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_fa6167069235e90735034a6c0401fff0.setIcon(
  icon_525597cef1e7495a82e5f66c7ba60660
);

var popup_b9cea188defc677e81a5973007527cc8 = L.popup({ maxWidth: "100%" });

var html_4915a2768b0df6dd8944e786fcfb92ac = $(
  `<div id="html_4915a2768b0df6dd8944e786fcfb92ac" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Durban<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Downtown Durban at sunset with Town Hall on the left. Must say we've been really surprised by Durban, it's a pretty coastal city with quite a bit to see. Recommend walking along the beach front and th<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1450126525069428/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -29.8289571<br>                     <strong>Longitude:</strong> 31.0303869<br>                     <strong>Date:</strong> Tuesday, 27th of June 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.553696<br>                 </div>             </div>`
)[0];
popup_b9cea188defc677e81a5973007527cc8.setContent(
  html_4915a2768b0df6dd8944e786fcfb92ac
);

marker_fa6167069235e90735034a6c0401fff0.bindPopup(
  popup_b9cea188defc677e81a5973007527cc8
);

var poly_line_9ee6325443f2ca1e18b8febe3e6671cd = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_af2f95347f2f22b171a98432ccb15031 = L.marker(
  [-28.766577, 32.112225],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_d6ec01dbed6c2870e155206d53e20b0a = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_af2f95347f2f22b171a98432ccb15031.setIcon(
  icon_d6ec01dbed6c2870e155206d53e20b0a
);

var popup_b8af5d779e4dc5fe3ef4888526545103 = L.popup({ maxWidth: "100%" });

var html_7ecb311f25414816d0197ee744ba7954 = $(
  `<div id="html_7ecb311f25414816d0197ee744ba7954" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Richards Bay<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> We are giving a talk on our adventures at Indaba Lodge tomorrow night (Friday) if anyone in or near Richards Bay KZM would like to come along. It's free, just come along and say hi to us and our girls<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1452303244851756/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -28.766577<br>                     <strong>Longitude:</strong> 32.112225<br>                     <strong>Date:</strong> Saturday, 1th of July 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 95.31023<br>                 </div>             </div>`
)[0];
popup_b8af5d779e4dc5fe3ef4888526545103.setContent(
  html_7ecb311f25414816d0197ee744ba7954
);

marker_af2f95347f2f22b171a98432ccb15031.bindPopup(
  popup_b8af5d779e4dc5fe3ef4888526545103
);

var poly_line_2e59d980b0231985287073c762234c36 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_f76f6754168980cbc58be7db490b6ae8 = L.marker(
  [-23.9883848, 31.5547402],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_7cd72a08f6880e2379106cc169d3e179 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_f76f6754168980cbc58be7db490b6ae8.setIcon(
  icon_7cd72a08f6880e2379106cc169d3e179
);

var popup_56bd786e553a81b1c22393ddf63d59fc = L.popup({ maxWidth: "100%" });

var html_d25220b59697eec189a53418198f92f1 = $(
  `<div id="html_d25220b59697eec189a53418198f92f1" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Phalaborwa<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> The Rhinos seemed to be the gentle Giants at Kruger. Just munching away on grass and wandering around, not fussed by tourists in their cars like some of the elephants 🐾 🐕  #PillionPooch #MadeToTravel <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1457358381012909/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -23.9883848<br>                     <strong>Longitude:</strong> 31.5547402<br>                     <strong>Date:</strong> Sunday, 2th of July 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.931404<br>                 </div>             </div>`
)[0];
popup_56bd786e553a81b1c22393ddf63d59fc.setContent(
  html_d25220b59697eec189a53418198f92f1
);

marker_f76f6754168980cbc58be7db490b6ae8.bindPopup(
  popup_56bd786e553a81b1c22393ddf63d59fc
);

var poly_line_6bf73c2427e06e04131e19d4e6a9ab40 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_6aedd5183566bf9c74795bcdf1887c11 = L.marker(
  [-28.58984, 31.39697],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_50579792696f113fa66c02408f067933 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_6aedd5183566bf9c74795bcdf1887c11.setIcon(
  icon_50579792696f113fa66c02408f067933
);

var popup_b2b70aae76843bf366ebfb1a73d8ee11 = L.popup({ maxWidth: "100%" });

var html_4a2fbeec271502f7f61232a55d7db0ca = $(
  `<div id="html_4a2fbeec271502f7f61232a55d7db0ca" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Melmoth<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> The Rhinos seemed to be the gentle Giants at Kruger. Just munching away on grass and wandering around, not fussed by tourists in their cars like some of the elephants 🐾 🐕  #PillionPooch #MadeToTravel <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1457358381012909/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -28.58984<br>                     <strong>Longitude:</strong> 31.39697<br>                     <strong>Date:</strong> Tuesday, 4th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_b2b70aae76843bf366ebfb1a73d8ee11.setContent(
  html_4a2fbeec271502f7f61232a55d7db0ca
);

marker_6aedd5183566bf9c74795bcdf1887c11.bindPopup(
  popup_b2b70aae76843bf366ebfb1a73d8ee11
);

var poly_line_58c6c7a63c67a4610bbbec268e2bb2d8 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_158d5ebbc42d123276439fe642bb795b = L.marker(
  [-27.73599, 29.98165],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_589417d388a98487d0d75fe4a8b3e32a = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_158d5ebbc42d123276439fe642bb795b.setIcon(
  icon_589417d388a98487d0d75fe4a8b3e32a
);

var popup_558205121792b9daa5f5de43b2c40d27 = L.popup({ maxWidth: "100%" });

var html_475224961d265052c0be0ec139f8d51f = $(
  `<div id="html_475224961d265052c0be0ec139f8d51f" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Newcastle<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> The Rhinos seemed to be the gentle Giants at Kruger. Just munching away on grass and wandering around, not fussed by tourists in their cars like some of the elephants 🐾 🐕  #PillionPooch #MadeToTravel <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1457358381012909/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -27.73599<br>                     <strong>Longitude:</strong> 29.98165<br>                     <strong>Date:</strong> Wednesday, 5th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_558205121792b9daa5f5de43b2c40d27.setContent(
  html_475224961d265052c0be0ec139f8d51f
);

marker_158d5ebbc42d123276439fe642bb795b.bindPopup(
  popup_558205121792b9daa5f5de43b2c40d27
);

var poly_line_e9c3d326f25ae9b234b7097ccc36a2d1 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_236da8b5ad0cfe9a6f9ac5a17f91329d = L.marker(
  [-26.1453, 28.15282],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_546a9ea3589c2c85ecde8ab41336cc3d = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_236da8b5ad0cfe9a6f9ac5a17f91329d.setIcon(
  icon_546a9ea3589c2c85ecde8ab41336cc3d
);

var popup_4e1ba50ea7971c78a901dd64bcbac31a = L.popup({ maxWidth: "100%" });

var html_9f8c21427d654d841530359c6455fd1b = $(
  `<div id="html_9f8c21427d654d841530359c6455fd1b" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Modderfontein<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> The Rhinos seemed to be the gentle Giants at Kruger. Just munching away on grass and wandering around, not fussed by tourists in their cars like some of the elephants 🐾 🐕  #PillionPooch #MadeToTravel <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1457358381012909/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -26.1453<br>                     <strong>Longitude:</strong> 28.15282<br>                     <strong>Date:</strong> Thursday, 6th of July 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.48134<br>                 </div>             </div>`
)[0];
popup_4e1ba50ea7971c78a901dd64bcbac31a.setContent(
  html_9f8c21427d654d841530359c6455fd1b
);

marker_236da8b5ad0cfe9a6f9ac5a17f91329d.bindPopup(
  popup_4e1ba50ea7971c78a901dd64bcbac31a
);

var poly_line_43669b1fa6b651cca63bef41b4b130a7 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_5b5368d5039508047b71453f618d31e0 = L.marker(
  [-28.643295, 29.158825],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_1b1ae10d112ab290b252c8eb9366d79b = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_5b5368d5039508047b71453f618d31e0.setIcon(
  icon_1b1ae10d112ab290b252c8eb9366d79b
);

var popup_8c30627e561410dc39b1872597a66cad = L.popup({ maxWidth: "100%" });

var html_acebeed4ee79298bdbfb141d72193245 = $(
  `<div id="html_acebeed4ee79298bdbfb141d72193245" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Bergville<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Check out our new promotional video. 2 weeks remaining of our Kickstarter Campaign, don't miss out on your opportunity to back the Pillion Pooch project.  https://www.thepacktrack.com/PillionPooch<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1462336970515050/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -28.643295<br>                     <strong>Longitude:</strong> 29.158825<br>                     <strong>Date:</strong> Sunday, 9th of July 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_8c30627e561410dc39b1872597a66cad.setContent(
  html_acebeed4ee79298bdbfb141d72193245
);

marker_5b5368d5039508047b71453f618d31e0.bindPopup(
  popup_8c30627e561410dc39b1872597a66cad
);

var poly_line_d52dabb4a081f283aca281c030fb8782 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_5e3c0945d76ca7ad794a21fa4e53b04a = L.marker(
  [-27.71397, 29.92232],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_ce39492b24878b1bf3cd68ca74b962ca = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_5e3c0945d76ca7ad794a21fa4e53b04a.setIcon(
  icon_ce39492b24878b1bf3cd68ca74b962ca
);

var popup_2fdf48a93eaeec4c557bcab4982d7321 = L.popup({ maxWidth: "100%" });

var html_148fbf0e0c472689ac48fbcc7011c784 = $(
  `<div id="html_148fbf0e0c472689ac48fbcc7011c784" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Newcastle<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> The Newcastle Advertiser, a local newspaper, wrote a nice piece about us. We will post the online link on our Facebook wall when it's available. 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureR<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1466167956798618/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -27.71397<br>                     <strong>Longitude:</strong> 29.92232<br>                     <strong>Date:</strong> Thursday, 13th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_2fdf48a93eaeec4c557bcab4982d7321.setContent(
  html_148fbf0e0c472689ac48fbcc7011c784
);

marker_5e3c0945d76ca7ad794a21fa4e53b04a.bindPopup(
  popup_2fdf48a93eaeec4c557bcab4982d7321
);

var poly_line_eeddf61732003da1af2bfec731d361c6 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_24363ff7927bc6effd2b84711fd7641f = L.marker(
  [-28.76607, 32.11327],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_f464150c39afc2d4903db474e3cfddb7 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_24363ff7927bc6effd2b84711fd7641f.setIcon(
  icon_f464150c39afc2d4903db474e3cfddb7
);

var popup_5878291ec82447403cc58fc254e1f08e = L.popup({ maxWidth: "100%" });

var html_ec8362741a0dc576664e42f95cc9e6eb = $(
  `<div id="html_ec8362741a0dc576664e42f95cc9e6eb" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Richards Bay<br>                     <strong>Country:</strong> South Africa<br>                                          <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1469007049848042/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -28.76607<br>                     <strong>Longitude:</strong> 32.11327<br>                     <strong>Date:</strong> Sunday, 16th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_5878291ec82447403cc58fc254e1f08e.setContent(
  html_ec8362741a0dc576664e42f95cc9e6eb
);

marker_24363ff7927bc6effd2b84711fd7641f.bindPopup(
  popup_5878291ec82447403cc58fc254e1f08e
);

var poly_line_032cb1a39d33ffb6440d2e319b0faecb = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_3679eead25afdcb0abf96d5f35ec0113 = L.marker(
  [-29.37294, 31.18832],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_84d661223e59fb8177423fb687853332 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_3679eead25afdcb0abf96d5f35ec0113.setIcon(
  icon_84d661223e59fb8177423fb687853332
);

var popup_cee1a1bc560fd0e7126d5b69010d88ec = L.popup({ maxWidth: "100%" });

var html_2f8d242753748d8a2cd71d8bdb8fc656 = $(
  `<div id="html_2f8d242753748d8a2cd71d8bdb8fc656" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Stanger<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Happy​ Monday boys and girls  🐾 #MotoDog #Dog #BikerDog #AdoptDontShop #DogsOnAdventures #Africa #PetTravel #DogAdoption #AdventureRider #PuppyLove #DogsOnBikes #BMW #MadeToTravel #PillionPooch #Cute <br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1469630966452317" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -29.37294<br>                     <strong>Longitude:</strong> 31.18832<br>                     <strong>Date:</strong> Tuesday, 18th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_cee1a1bc560fd0e7126d5b69010d88ec.setContent(
  html_2f8d242753748d8a2cd71d8bdb8fc656
);

marker_3679eead25afdcb0abf96d5f35ec0113.bindPopup(
  popup_cee1a1bc560fd0e7126d5b69010d88ec
);

var poly_line_b0b7443423dd5c8e3fe4800a74341793 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_54d57928bb46f2f78973cf654bb362c8 = L.marker(
  [-27.74179, 30.72241],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_e474303c81ac2689975ae0e975bbb5e3 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_54d57928bb46f2f78973cf654bb362c8.setIcon(
  icon_e474303c81ac2689975ae0e975bbb5e3
);

var popup_d7473c4c845a888df58a2a6040b4f077 = L.popup({ maxWidth: "100%" });

var html_7664658b20228583eb6e63fc74dbabb1 = $(
  `<div id="html_7664658b20228583eb6e63fc74dbabb1" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Vryheid<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> A little footage of our visit to Animally Haven, home to dogs, cats, pigs and rabbits  🐾 #BMW #MotorcycleAdventure #AdventureDog #AdoptDontShop #Cute #DogAdoption #PillionPooch #MotoDog #Dog #DogsOnAd<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1472229719525775" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -27.74179<br>                     <strong>Longitude:</strong> 30.72241<br>                     <strong>Date:</strong> Wednesday, 19th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_d7473c4c845a888df58a2a6040b4f077.setContent(
  html_7664658b20228583eb6e63fc74dbabb1
);

marker_54d57928bb46f2f78973cf654bb362c8.bindPopup(
  popup_d7473c4c845a888df58a2a6040b4f077
);

var poly_line_9abf12e1810705d8dc1a908ddb293984 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_a05ed4877d9817acabb2cfca05285874 = L.marker(
  [-26.20183, 31.19853],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_5322c3cfd38660521153180f3405dfc8 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_a05ed4877d9817acabb2cfca05285874.setIcon(
  icon_5322c3cfd38660521153180f3405dfc8
);

var popup_4c9dd6989955bbb8d90da5b3b51a810a = L.popup({ maxWidth: "100%" });

var html_3da28329aa738fe5310baa295838c211 = $(
  `<div id="html_3da28329aa738fe5310baa295838c211" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mbabane<br>                     <strong>Country:</strong> Eswatini<br>                     <strong>Post:</strong> A little footage of our visit to Animally Haven, home to dogs, cats, pigs and rabbits  🐾 #BMW #MotorcycleAdventure #AdventureDog #AdoptDontShop #Cute #DogAdoption #PillionPooch #MotoDog #Dog #DogsOnAd<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1472229719525775" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -26.20183<br>                     <strong>Longitude:</strong> 31.19853<br>                     <strong>Date:</strong> Thursday, 20th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_4c9dd6989955bbb8d90da5b3b51a810a.setContent(
  html_3da28329aa738fe5310baa295838c211
);

marker_a05ed4877d9817acabb2cfca05285874.bindPopup(
  popup_4c9dd6989955bbb8d90da5b3b51a810a
);

var poly_line_673947f0bfde84d1cda0f2b5b943acde = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_7e7dd5c51a62fc8bca262a72a1f8ac5a = L.marker(
  [-25.71761, 28.26542],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_b6916dba9a165a69195865a9ba16ebc7 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_7e7dd5c51a62fc8bca262a72a1f8ac5a.setIcon(
  icon_b6916dba9a165a69195865a9ba16ebc7
);

var popup_a679847448cb6694994127fa3f646d28 = L.popup({ maxWidth: "100%" });

var html_3f9800b7e7bb4834f8283e8fde11a3fa = $(
  `<div id="html_3f9800b7e7bb4834f8283e8fde11a3fa" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Pretoria<br>                     <strong>Country:</strong> South Africa<br>                     <strong>Post:</strong> Oh Shadow,  nothing beats a Sunday ride and snooze in the sun 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #Pup<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1477627238986023/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -25.71761<br>                     <strong>Longitude:</strong> 28.26542<br>                     <strong>Date:</strong> Monday, 24th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_a679847448cb6694994127fa3f646d28.setContent(
  html_3f9800b7e7bb4834f8283e8fde11a3fa
);

marker_7e7dd5c51a62fc8bca262a72a1f8ac5a.bindPopup(
  popup_a679847448cb6694994127fa3f646d28
);

var poly_line_2f5f0d778dfec2239c350afb169acc3b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_bb01ec2d499d92443f88dd1b2aca5c08 = L.marker(
  [-22.47678, 27.16376],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_bf70ab4c09dae42c42c28c712816c8bc = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_bb01ec2d499d92443f88dd1b2aca5c08.setIcon(
  icon_bf70ab4c09dae42c42c28c712816c8bc
);

var popup_667581ff6b7b5e39bb59498d52e05cdc = L.popup({ maxWidth: "100%" });

var html_41bee3b9478886cfcf171848c3f3af04 = $(
  `<div id="html_41bee3b9478886cfcf171848c3f3af04" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Palapye<br>                     <strong>Country:</strong> Botswana<br>                     <strong>Post:</strong> Oh Shadow,  nothing beats a Sunday ride and snooze in the sun 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #Pup<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1477627238986023/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -22.47678<br>                     <strong>Longitude:</strong> 27.16376<br>                     <strong>Date:</strong> Tuesday, 25th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_667581ff6b7b5e39bb59498d52e05cdc.setContent(
  html_41bee3b9478886cfcf171848c3f3af04
);

marker_bb01ec2d499d92443f88dd1b2aca5c08.bindPopup(
  popup_667581ff6b7b5e39bb59498d52e05cdc
);

var poly_line_37a117582428b984b726009ba15d803c = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_34e869ea582e687bccf0671dbd7c1549 = L.marker(
  [-21.20041, 27.5224],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_0fed5cdd801dd746ddad7190bb200fdc = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_34e869ea582e687bccf0671dbd7c1549.setIcon(
  icon_0fed5cdd801dd746ddad7190bb200fdc
);

var popup_b916d6053fcbe39bbc1ad47e36214789 = L.popup({ maxWidth: "100%" });

var html_0085c4c05f51c68c4c131085308ee9ed = $(
  `<div id="html_0085c4c05f51c68c4c131085308ee9ed" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Francistown<br>                     <strong>Country:</strong> Botswana<br>                     <strong>Post:</strong> We FINALLY had the real African Elephant experience today riding in Zimbabwe Negrita and Shadow saw real life wild Elephants from the comfort and safety on their Safari motorbike.  We are over the moo<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1479717358777011" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -21.20041<br>                     <strong>Longitude:</strong> 27.5224<br>                     <strong>Date:</strong> Wednesday, 26th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_b916d6053fcbe39bbc1ad47e36214789.setContent(
  html_0085c4c05f51c68c4c131085308ee9ed
);

marker_34e869ea582e687bccf0671dbd7c1549.bindPopup(
  popup_b916d6053fcbe39bbc1ad47e36214789
);

var poly_line_9d501922bcd2c5f9c9ccea14888256b0 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_956cc83c9b5051b89d94e8c7a90529a9 = L.marker(
  [-18.67928, 26.94052],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_18824f27295fdb38143005a4e0b1a9cb = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_956cc83c9b5051b89d94e8c7a90529a9.setIcon(
  icon_18824f27295fdb38143005a4e0b1a9cb
);

var popup_5d2e3e45f0665c9f5ed2b71b96137b71 = L.popup({ maxWidth: "100%" });

var html_8b20e4270971645216f02ada4dd749bf = $(
  `<div id="html_8b20e4270971645216f02ada4dd749bf" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Dete<br>                     <strong>Country:</strong> Zimbabwe<br>                     <strong>Post:</strong> We FINALLY had the real African Elephant experience today riding in Zimbabwe Negrita and Shadow saw real life wild Elephants from the comfort and safety on their Safari motorbike.  We are over the moo<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1479717358777011" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -18.67928<br>                     <strong>Longitude:</strong> 26.94052<br>                     <strong>Date:</strong> Friday, 28th of July 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_5d2e3e45f0665c9f5ed2b71b96137b71.setContent(
  html_8b20e4270971645216f02ada4dd749bf
);

marker_956cc83c9b5051b89d94e8c7a90529a9.bindPopup(
  popup_5d2e3e45f0665c9f5ed2b71b96137b71
);

var poly_line_182904e78a242ae2d49a9d7fd17cc4e4 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_79609f12ef0a381f8c070f76f3dab327 = L.marker(
  [-17.92937, 25.8383],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_833f97380218107737775d880cde63a3 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_79609f12ef0a381f8c070f76f3dab327.setIcon(
  icon_833f97380218107737775d880cde63a3
);

var popup_62491c844878b2c2b2ebe77095a0878a = L.popup({ maxWidth: "100%" });

var html_156cb4ce8486f4f614af64255addfc44 = $(
  `<div id="html_156cb4ce8486f4f614af64255addfc44" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Victoria Falls<br>                     <strong>Country:</strong> Zimbabwe<br>                     <strong>Post:</strong> Adventure day at Victoria Falls. The slide, swing and bungee.<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1484015078347239/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -17.92937<br>                     <strong>Longitude:</strong> 25.8383<br>                     <strong>Date:</strong> Wednesday, 2th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_62491c844878b2c2b2ebe77095a0878a.setContent(
  html_156cb4ce8486f4f614af64255addfc44
);

marker_79609f12ef0a381f8c070f76f3dab327.bindPopup(
  popup_62491c844878b2c2b2ebe77095a0878a
);

var poly_line_f2f1a620a7f8d3438a91c675514051df = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_e525c8662bd6e8368fbae02ad9aa5ecb = L.marker(
  [-16.8298, 26.93745],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_dce7bd32f33ca2a4804a4ee9b5968659 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_e525c8662bd6e8368fbae02ad9aa5ecb.setIcon(
  icon_dce7bd32f33ca2a4804a4ee9b5968659
);

var popup_6bf34fd6414680c89d867a43d0bde6d1 = L.popup({ maxWidth: "100%" });

var html_b96ca507f9facf43193de0198f15668b = $(
  `<div id="html_b96ca507f9facf43193de0198f15668b" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Choma<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> Adventure day at Victoria Falls. The slide, swing and bungee.<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1484015078347239/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -16.8298<br>                     <strong>Longitude:</strong> 26.93745<br>                     <strong>Date:</strong> Thursday, 3th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_6bf34fd6414680c89d867a43d0bde6d1.setContent(
  html_b96ca507f9facf43193de0198f15668b
);

marker_e525c8662bd6e8368fbae02ad9aa5ecb.bindPopup(
  popup_6bf34fd6414680c89d867a43d0bde6d1
);

var poly_line_dadc9d8117688d1a3026c5262f379b70 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_de6d5b82e411b2ea7858f7ca12b16683 = L.marker(
  [-15.40834, 28.28104],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_b94069e29493849756e4351729d9fecb = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_de6d5b82e411b2ea7858f7ca12b16683.setIcon(
  icon_b94069e29493849756e4351729d9fecb
);

var popup_8ad2c9d95154a7f454beb2819b240e99 = L.popup({ maxWidth: "100%" });

var html_7d0b469d3f5f6d5abda744d3b82efd0c = $(
  `<div id="html_7d0b469d3f5f6d5abda744d3b82efd0c" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Lusaka<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> Product placement at Victoria Falls 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1492927207456026/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -15.40834<br>                     <strong>Longitude:</strong> 28.28104<br>                     <strong>Date:</strong> Friday, 11th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_8ad2c9d95154a7f454beb2819b240e99.setContent(
  html_7d0b469d3f5f6d5abda744d3b82efd0c
);

marker_de6d5b82e411b2ea7858f7ca12b16683.bindPopup(
  popup_8ad2c9d95154a7f454beb2819b240e99
);

var poly_line_6ead68cae605a2ce53a52f2f7275dd09 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_83a46c45d4676950d2a6b2bb69dc386f = L.marker(
  [-14.44144, 28.44905],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_00936b900c61678fa87da3b459b54cf0 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_83a46c45d4676950d2a6b2bb69dc386f.setIcon(
  icon_00936b900c61678fa87da3b459b54cf0
);

var popup_28c77029e355a82c52078a2350905c3c = L.popup({ maxWidth: "100%" });

var html_1306f3d40f6992a60b3e806f45070f52 = $(
  `<div id="html_1306f3d40f6992a60b3e806f45070f52" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kabwe<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> Trying to stay awake, but not very successfully 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOn<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1495008330581247/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -14.44144<br>                     <strong>Longitude:</strong> 28.44905<br>                     <strong>Date:</strong> Sunday, 13th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_28c77029e355a82c52078a2350905c3c.setContent(
  html_1306f3d40f6992a60b3e806f45070f52
);

marker_83a46c45d4676950d2a6b2bb69dc386f.bindPopup(
  popup_28c77029e355a82c52078a2350905c3c
);

var poly_line_5f594a906c09fa3208d07db8a069326a = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_c821dfa3a77d289ed7568a3eb414af72 = L.marker(
  [-13.05101, 28.46319],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_fb40c1859a9703ce753e3a1e45bb1ccd = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_c821dfa3a77d289ed7568a3eb414af72.setIcon(
  icon_fb40c1859a9703ce753e3a1e45bb1ccd
);

var popup_128dd66b8cadc182e0beeaca1e4b5c04 = L.popup({ maxWidth: "100%" });

var html_c21d5a926c9547bc28ec655ae8482b90 = $(
  `<div id="html_c21d5a926c9547bc28ec655ae8482b90" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Luanshya<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> Trying to stay awake, but not very successfully 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOn<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1495008330581247/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -13.05101<br>                     <strong>Longitude:</strong> 28.46319<br>                     <strong>Date:</strong> Monday, 14th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_128dd66b8cadc182e0beeaca1e4b5c04.setContent(
  html_c21d5a926c9547bc28ec655ae8482b90
);

marker_c821dfa3a77d289ed7568a3eb414af72.bindPopup(
  popup_128dd66b8cadc182e0beeaca1e4b5c04
);

var poly_line_159c703a865a2f9c3f70b44edf2d41dd = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_6644ffddfcc9a1cf11a73d5d46503210 = L.marker(
  [-12.36581, 27.48194],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_4767d4b81bef742a060316ab77ff8f92 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_6644ffddfcc9a1cf11a73d5d46503210.setIcon(
  icon_4767d4b81bef742a060316ab77ff8f92
);

var popup_940c02c69dab2401e6fddb30ce4bc9c5 = L.popup({ maxWidth: "100%" });

var html_8126e3313a3101a327a18fe1010b6aac = $(
  `<div id="html_8126e3313a3101a327a18fe1010b6aac" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Chililabombwe<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> We had the honour of staying with Sheila Siddle and her daughter Sylvia at Chimfunshi Wildlife Orphanage. Sheila saved her first Chimpanzee in 1983 and subsequently created this home away from home fo<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1499416910140389/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -12.36581<br>                     <strong>Longitude:</strong> 27.48194<br>                     <strong>Date:</strong> Thursday, 17th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_940c02c69dab2401e6fddb30ce4bc9c5.setContent(
  html_8126e3313a3101a327a18fe1010b6aac
);

marker_6644ffddfcc9a1cf11a73d5d46503210.bindPopup(
  popup_940c02c69dab2401e6fddb30ce4bc9c5
);

var poly_line_717d70421d6950ea1153ba51ff7c8773 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_05573873aadbc465a85c9d5b78d99b7a = L.marker(
  [-13.05788, 28.45596],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_835603d1baef26d9c64f36fd4d89d607 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_05573873aadbc465a85c9d5b78d99b7a.setIcon(
  icon_835603d1baef26d9c64f36fd4d89d607
);

var popup_aa73c6b0aef84c679b6c291c85e1f60c = L.popup({ maxWidth: "100%" });

var html_c9e8097f1ff89241c6948049708970e5 = $(
  `<div id="html_c9e8097f1ff89241c6948049708970e5" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Luanshya<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> Having dinner with Janet of Lowden Lodge last night we discovered Zambia was playing against South Africa about 20km from us in Ndola. We got out early today and queued for tickets at the local superm<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1500302216718525/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -13.05788<br>                     <strong>Longitude:</strong> 28.45596<br>                     <strong>Date:</strong> Sunday, 20th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_aa73c6b0aef84c679b6c291c85e1f60c.setContent(
  html_c9e8097f1ff89241c6948049708970e5
);

marker_05573873aadbc465a85c9d5b78d99b7a.bindPopup(
  popup_aa73c6b0aef84c679b6c291c85e1f60c
);

var poly_line_a242ca1d91ddcccdc04651c44e9a05e1 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_1f4cb4d7f43d2833a856369ecd29aaf5 = L.marker(
  [-13.53668, 29.73036],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_15753841766fecb77be188d1415dfb15 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_1f4cb4d7f43d2833a856369ecd29aaf5.setIcon(
  icon_15753841766fecb77be188d1415dfb15
);

var popup_7c83f0f4a54d335ab7faed1f9d5dcb2c = L.popup({ maxWidth: "100%" });

var html_7dd7b62badb5990715d8722718dfe296 = $(
  `<div id="html_7dd7b62badb5990715d8722718dfe296" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mkushi<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> Having dinner with Janet of Lowden Lodge last night we discovered Zambia was playing against South Africa about 20km from us in Ndola. We got out early today and queued for tickets at the local superm<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1500302216718525/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -13.53668<br>                     <strong>Longitude:</strong> 29.73036<br>                     <strong>Date:</strong> Monday, 21th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_7c83f0f4a54d335ab7faed1f9d5dcb2c.setContent(
  html_7dd7b62badb5990715d8722718dfe296
);

marker_1f4cb4d7f43d2833a856369ecd29aaf5.bindPopup(
  popup_7c83f0f4a54d335ab7faed1f9d5dcb2c
);

var poly_line_4eb06fbddf73d70db3d99bcfdc6a3938 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_539eb31de745fde9268d1d9bd5a4d4ba = L.marker(
  [-11.84549, 31.44656],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_8acc9e9dcd629e4291927df84d5791c9 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_539eb31de745fde9268d1d9bd5a4d4ba.setIcon(
  icon_8acc9e9dcd629e4291927df84d5791c9
);

var popup_98eecfdf582e05a5f76b88eb31d8e3a2 = L.popup({ maxWidth: "100%" });

var html_67907539604db19432d10bcaa9ead927 = $(
  `<div id="html_67907539604db19432d10bcaa9ead927" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mpika<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> Having dinner with Janet of Lowden Lodge last night we discovered Zambia was playing against South Africa about 20km from us in Ndola. We got out early today and queued for tickets at the local superm<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1500302216718525/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -11.84549<br>                     <strong>Longitude:</strong> 31.44656<br>                     <strong>Date:</strong> Tuesday, 22th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_98eecfdf582e05a5f76b88eb31d8e3a2.setContent(
  html_67907539604db19432d10bcaa9ead927
);

marker_539eb31de745fde9268d1d9bd5a4d4ba.bindPopup(
  popup_98eecfdf582e05a5f76b88eb31d8e3a2
);

var poly_line_6f86c45f5a88ab73255dbde6e1013468 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_51c97cae3707aa1cd5a1d86d6753f5dd = L.marker(
  [-8.87086, 31.33826],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_dfd49fababd4542505050649b6d38e29 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_51c97cae3707aa1cd5a1d86d6753f5dd.setIcon(
  icon_dfd49fababd4542505050649b6d38e29
);

var popup_0ba9194f58f17cda45ef89ec444413ce = L.popup({ maxWidth: "100%" });

var html_13ce17f042d9a73015d1cef31f8528f7 = $(
  `<div id="html_13ce17f042d9a73015d1cef31f8528f7" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mbala<br>                     <strong>Country:</strong> Zambia<br>                     <strong>Post:</strong> This looked like a train accident but upon closer inspection we realised it was old but the locals were back burning in preparation for summer 🐾 🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRid<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1506080886140658/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -8.87086<br>                     <strong>Longitude:</strong> 31.33826<br>                     <strong>Date:</strong> Wednesday, 23th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_0ba9194f58f17cda45ef89ec444413ce.setContent(
  html_13ce17f042d9a73015d1cef31f8528f7
);

marker_51c97cae3707aa1cd5a1d86d6753f5dd.bindPopup(
  popup_0ba9194f58f17cda45ef89ec444413ce
);

var poly_line_62e8dbbfee937f7f3a749e84ea2f3cd0 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_6531d88eca7ec30f3883b89f8593d711 = L.marker(
  [-8.93092, 33.30932],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_ba34d6dad00bef712b5a7295463d085c = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_6531d88eca7ec30f3883b89f8593d711.setIcon(
  icon_ba34d6dad00bef712b5a7295463d085c
);

var popup_6b3d64a7469c35b60ff347d5e11ecf06 = L.popup({ maxWidth: "100%" });

var html_18a91d1309ad2d3868e22f2a9c3665e6 = $(
  `<div id="html_18a91d1309ad2d3868e22f2a9c3665e6" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mbeya<br>                     <strong>Country:</strong> Tanzania, United Republic of<br>                     <strong>Post:</strong> Our first night in Tanzania. Landscape changed very quickly from flat to hilly but still remaining over 1,500m in elevation. Cool riding days and nights even though we are only a few degrees from the <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1507379179344162/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -8.93092<br>                     <strong>Longitude:</strong> 33.30932<br>                     <strong>Date:</strong> Sunday, 27th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_6b3d64a7469c35b60ff347d5e11ecf06.setContent(
  html_18a91d1309ad2d3868e22f2a9c3665e6
);

marker_6531d88eca7ec30f3883b89f8593d711.bindPopup(
  popup_6b3d64a7469c35b60ff347d5e11ecf06
);

var poly_line_7f314464e5dc8c5c11b28f578825bacd = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_ce9862b4ec28a7d94066b23ca826a628 = L.marker(
  [-7.75603, 35.70664],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_1d20afd7290178b91b90672950e54e4e = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_ce9862b4ec28a7d94066b23ca826a628.setIcon(
  icon_1d20afd7290178b91b90672950e54e4e
);

var popup_37d7e546fc331cc0ba667293bdce43b1 = L.popup({ maxWidth: "100%" });

var html_bf6fc7de116d428906701ebbeff9d8e0 = $(
  `<div id="html_bf6fc7de116d428906701ebbeff9d8e0" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Iringa<br>                     <strong>Country:</strong> Tanzania, United Republic of<br>                     <strong>Post:</strong> Our first night in Tanzania. Landscape changed very quickly from flat to hilly but still remaining over 1,500m in elevation. Cool riding days and nights even though we are only a few degrees from the <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1507379179344162/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -7.75603<br>                     <strong>Longitude:</strong> 35.70664<br>                     <strong>Date:</strong> Monday, 28th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_37d7e546fc331cc0ba667293bdce43b1.setContent(
  html_bf6fc7de116d428906701ebbeff9d8e0
);

marker_ce9862b4ec28a7d94066b23ca826a628.bindPopup(
  popup_37d7e546fc331cc0ba667293bdce43b1
);

var poly_line_b6287fb9328a7c3fd39745acf8ee8815 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_8e1c6a52d2d90fd5f27c002c4c3e2ea4 = L.marker(
  [-6.02933, 35.75672],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_ea35ff15226e6d670fb7b3d694e2e428 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_8e1c6a52d2d90fd5f27c002c4c3e2ea4.setIcon(
  icon_ea35ff15226e6d670fb7b3d694e2e428
);

var popup_4d73554a9c24e26f21eefc163d76594a = L.popup({ maxWidth: "100%" });

var html_4a3168e4cc72ab6484e2b7096bfb4d0d = $(
  `<div id="html_4a3168e4cc72ab6484e2b7096bfb4d0d" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Dodoma<br>                     <strong>Country:</strong> Tanzania, United Republic of<br>                     <strong>Post:</strong> Our first night in Tanzania. Landscape changed very quickly from flat to hilly but still remaining over 1,500m in elevation. Cool riding days and nights even though we are only a few degrees from the <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1507379179344162/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -6.02933<br>                     <strong>Longitude:</strong> 35.75672<br>                     <strong>Date:</strong> Tuesday, 29th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_4d73554a9c24e26f21eefc163d76594a.setContent(
  html_4a3168e4cc72ab6484e2b7096bfb4d0d
);

marker_8e1c6a52d2d90fd5f27c002c4c3e2ea4.bindPopup(
  popup_4d73554a9c24e26f21eefc163d76594a
);

var poly_line_d54f22642836e70d8d5e113a3a76e7c2 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b00485c75dd55447216a7c1444972bb2 = L.marker(
  [-3.36664, 36.71092],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_2682acb580dde17c4d57ebe6ca163258 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b00485c75dd55447216a7c1444972bb2.setIcon(
  icon_2682acb580dde17c4d57ebe6ca163258
);

var popup_bafc1dcf3b716c91d68339c1f9d9dbac = L.popup({ maxWidth: "100%" });

var html_6fa81487bde0ffbf05c833cda300100a = $(
  `<div id="html_6fa81487bde0ffbf05c833cda300100a" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Arusha<br>                     <strong>Country:</strong> Tanzania, United Republic of<br>                     <strong>Post:</strong> Just posted this issue in the ADV Rider Forum and thought we'd share it to see if anyone here could help.  We have an issue that we're hoping someone can help with. Today we went for a ride, mainly of<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1510477892367624/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -3.36664<br>                     <strong>Longitude:</strong> 36.71092<br>                     <strong>Date:</strong> Wednesday, 30th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_bafc1dcf3b716c91d68339c1f9d9dbac.setContent(
  html_6fa81487bde0ffbf05c833cda300100a
);

marker_b00485c75dd55447216a7c1444972bb2.bindPopup(
  popup_bafc1dcf3b716c91d68339c1f9d9dbac
);

var poly_line_c70bd939466dbaf6dea9d79ddf70748b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_6a4a0d8a203dc15e8bfc2d36ff0d8831 = L.marker(
  [-3.13345, 37.60715],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_22adca95b930f989fd9db4b5973f9933 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_6a4a0d8a203dc15e8bfc2d36ff0d8831.setIcon(
  icon_22adca95b930f989fd9db4b5973f9933
);

var popup_ce470d8533d846713f1193ad5500bec8 = L.popup({ maxWidth: "100%" });

var html_d6145175e8a74810221fb0bd9471aba1 = $(
  `<div id="html_d6145175e8a74810221fb0bd9471aba1" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Taveta<br>                     <strong>Country:</strong> Kenya<br>                     <strong>Post:</strong> Just posted this issue in the ADV Rider Forum and thought we'd share it to see if anyone here could help.  We have an issue that we're hoping someone can help with. Today we went for a ride, mainly of<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1510477892367624/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -3.13345<br>                     <strong>Longitude:</strong> 37.60715<br>                     <strong>Date:</strong> Thursday, 31th of August 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_ce470d8533d846713f1193ad5500bec8.setContent(
  html_d6145175e8a74810221fb0bd9471aba1
);

marker_6a4a0d8a203dc15e8bfc2d36ff0d8831.bindPopup(
  popup_ce470d8533d846713f1193ad5500bec8
);

var poly_line_07fa28c915a374ba69d4173e5c02d9aa = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_a213c544dc3a83ca23d84e2e18684705 = L.marker(
  [-3.37721, 35.82771],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_eee59a9629d7864ece408dbbe6efb789 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_a213c544dc3a83ca23d84e2e18684705.setIcon(
  icon_eee59a9629d7864ece408dbbe6efb789
);

var popup_559f9cf3350f86a30bb6a49fdec49de3 = L.popup({ maxWidth: "100%" });

var html_ac3f551fc279b2a56216fb37befb98c4 = $(
  `<div id="html_ac3f551fc279b2a56216fb37befb98c4" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mto wa Mbu<br>                     <strong>Country:</strong> Tanzania, United Republic of<br>                     <strong>Post:</strong> We're in Rwanda! 🐾  🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoption #Adopt<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1515679311847482/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -3.37721<br>                     <strong>Longitude:</strong> 35.82771<br>                     <strong>Date:</strong> Sunday, 3th of September 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_559f9cf3350f86a30bb6a49fdec49de3.setContent(
  html_ac3f551fc279b2a56216fb37befb98c4
);

marker_a213c544dc3a83ca23d84e2e18684705.bindPopup(
  popup_559f9cf3350f86a30bb6a49fdec49de3
);

var poly_line_ac5e59a11cc06e62938f41e886015699 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_c905e751bfb81a97f2ca7e8769e07319 = L.marker(
  [-4.70145, 34.69961],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_c142c25b4c672a80e7f79a8763afdbc9 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_c905e751bfb81a97f2ca7e8769e07319.setIcon(
  icon_c142c25b4c672a80e7f79a8763afdbc9
);

var popup_41803785540c56065cc4f3edd7b29f0d = L.popup({ maxWidth: "100%" });

var html_38cb947fc54cc3eb8f5bd9c0fa2f9b94 = $(
  `<div id="html_38cb947fc54cc3eb8f5bd9c0fa2f9b94" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Singida<br>                     <strong>Country:</strong> Tanzania, United Republic of<br>                     <strong>Post:</strong> We're in Rwanda! 🐾  🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoption #Adopt<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1515679311847482/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -4.70145<br>                     <strong>Longitude:</strong> 34.69961<br>                     <strong>Date:</strong> Monday, 4th of September 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_41803785540c56065cc4f3edd7b29f0d.setContent(
  html_38cb947fc54cc3eb8f5bd9c0fa2f9b94
);

marker_c905e751bfb81a97f2ca7e8769e07319.bindPopup(
  popup_41803785540c56065cc4f3edd7b29f0d
);

var poly_line_e51026c8a8473f4b5a6c0b1784a3b607 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b3cbd2e6120fdd37c689ad88f855fba8 = L.marker(
  [-4.21892, 33.15663],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_2bbd2af984c8ced2b6c3538c9268bcd2 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b3cbd2e6120fdd37c689ad88f855fba8.setIcon(
  icon_2bbd2af984c8ced2b6c3538c9268bcd2
);

var popup_0ebbd161c22e0c59544d9c0f29514bd4 = L.popup({ maxWidth: "100%" });

var html_d151166e1f5bed399f5d67370c9fbb19 = $(
  `<div id="html_d151166e1f5bed399f5d67370c9fbb19" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Nzega<br>                     <strong>Country:</strong> Tanzania, United Republic of<br>                     <strong>Post:</strong> We're in Rwanda! 🐾  🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoption #Adopt<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1515679311847482/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -4.21892<br>                     <strong>Longitude:</strong> 33.15663<br>                     <strong>Date:</strong> Tuesday, 5th of September 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_0ebbd161c22e0c59544d9c0f29514bd4.setContent(
  html_d151166e1f5bed399f5d67370c9fbb19
);

marker_b3cbd2e6120fdd37c689ad88f855fba8.bindPopup(
  popup_0ebbd161c22e0c59544d9c0f29514bd4
);

var poly_line_6a725f52186509da36c2c94f02f707d8 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_ea6f2eb86e916b08be8a7f56015a1d53 = L.marker(
  [-2.49969, 30.85266],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_fa5df27e02ede6fd101f546b31b73ba7 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_ea6f2eb86e916b08be8a7f56015a1d53.setIcon(
  icon_fa5df27e02ede6fd101f546b31b73ba7
);

var popup_365b7182a15aec607154d7f31e99d521 = L.popup({ maxWidth: "100%" });

var html_6e632149d7012c38c820b625a6dab83d = $(
  `<div id="html_6e632149d7012c38c820b625a6dab83d" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ngara<br>                     <strong>Country:</strong> Tanzania, United Republic of<br>                     <strong>Post:</strong> We're in Rwanda! 🐾  🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoption #Adopt<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1515679311847482/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -2.49969<br>                     <strong>Longitude:</strong> 30.85266<br>                     <strong>Date:</strong> Wednesday, 6th of September 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_365b7182a15aec607154d7f31e99d521.setContent(
  html_6e632149d7012c38c820b625a6dab83d
);

marker_ea6f2eb86e916b08be8a7f56015a1d53.bindPopup(
  popup_365b7182a15aec607154d7f31e99d521
);

var poly_line_646addd1c142127587082532f7ba6ed0 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_776f4206d64036af9d744fed44583cf6 = L.marker(
  [-1.95403, 30.09906],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_92c8ef52cfac9c6affad840cfe3af453 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_776f4206d64036af9d744fed44583cf6.setIcon(
  icon_92c8ef52cfac9c6affad840cfe3af453
);

var popup_8b90122880a9a27f4079b5fb677b3114 = L.popup({ maxWidth: "100%" });

var html_404b42e4b39598252fbede6a63b0b47d = $(
  `<div id="html_404b42e4b39598252fbede6a63b0b47d" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kigali<br>                     <strong>Country:</strong> Rwanda<br>                     <strong>Post:</strong> We're in Rwanda! 🐾  🐕  #PillionPooch #MadeToTravel #Cute #Dog #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #PuppyLove #DogsOnBikes #BMW #DogAdoption #Adopt<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1515679311847482/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -1.95403<br>                     <strong>Longitude:</strong> 30.09906<br>                     <strong>Date:</strong> Sunday, 10th of September 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_8b90122880a9a27f4079b5fb677b3114.setContent(
  html_404b42e4b39598252fbede6a63b0b47d
);

marker_776f4206d64036af9d744fed44583cf6.bindPopup(
  popup_8b90122880a9a27f4079b5fb677b3114
);

var poly_line_5ef7f2943f56e80894919fe839169bc2 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_c93ccfc182f595a45bd18ccbb4e44997 = L.marker(
  [-0.26894, 31.81332],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_d28dfebfdb0337d3f979bf37ededf40d = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_c93ccfc182f595a45bd18ccbb4e44997.setIcon(
  icon_d28dfebfdb0337d3f979bf37ededf40d
);

var popup_40b945f792ad87f95c86281e85494494 = L.popup({ maxWidth: "100%" });

var html_978667608cd815f3725f5f3bffd97741 = $(
  `<div id="html_978667608cd815f3725f5f3bffd97741" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Masaka<br>                     <strong>Country:</strong> Uganda<br>                     <strong>Post:</strong> So lovely to be mentioned after our fun stay at Villa Katwe. 🐾  🐕  #PillionPooch #MadeToTravel #MinPin #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #PetTravel #BikerDog #DogsOn<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1528856593863087/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -0.26894<br>                     <strong>Longitude:</strong> 31.81332<br>                     <strong>Date:</strong> Friday, 22th of September 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_40b945f792ad87f95c86281e85494494.setContent(
  html_978667608cd815f3725f5f3bffd97741
);

marker_c93ccfc182f595a45bd18ccbb4e44997.bindPopup(
  popup_40b945f792ad87f95c86281e85494494
);

var poly_line_6916b9f8066a45494b1f5bbb3a8ba343 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_7cb92e72822bed52d749a174e6bc9fb0 = L.marker(
  [0.27088, 32.56564],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_9fa17b2d6136b7675c4bdd0a813c3293 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_7cb92e72822bed52d749a174e6bc9fb0.setIcon(
  icon_9fa17b2d6136b7675c4bdd0a813c3293
);

var popup_806b5d089a03a18c6f2195702f03ec90 = L.popup({ maxWidth: "100%" });

var html_cabb7838f1d147189e531a7d9df75bcb = $(
  `<div id="html_cabb7838f1d147189e531a7d9df75bcb" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kampala<br>                     <strong>Country:</strong> Uganda<br>                     <strong>Post:</strong> Hanging out in Uganda The Pack Track are having a blast touring around the Kampala Central Division region of Uganda, if you happen to be within the vaccinity then please get in touch. #MadeToTravel #<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1530231460392267/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 0.27088<br>                     <strong>Longitude:</strong> 32.56564<br>                     <strong>Date:</strong> Sunday, 24th of September 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_806b5d089a03a18c6f2195702f03ec90.setContent(
  html_cabb7838f1d147189e531a7d9df75bcb
);

marker_7cb92e72822bed52d749a174e6bc9fb0.bindPopup(
  popup_806b5d089a03a18c6f2195702f03ec90
);

var poly_line_0469cea3fd12bdefe37d4fc84215efb4 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_9505dff59504674526193fdf7e1604f1 = L.marker(
  [0.09077, 34.53698],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_6ae68d7425c68cc47c30a8a7fa70e807 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_9505dff59504674526193fdf7e1604f1.setIcon(
  icon_6ae68d7425c68cc47c30a8a7fa70e807
);

var popup_9f6e2dc5165c715ec659ec035882fb76 = L.popup({ maxWidth: "100%" });

var html_ea857844c46b5b41a8f4b6ed9acc4a31 = $(
  `<div id="html_ea857844c46b5b41a8f4b6ed9acc4a31" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Yala<br>                     <strong>Country:</strong> Kenya<br>                     <strong>Post:</strong> Fun Fact: the equator runs through Uganda. There is an awful lot of land in the northern hemisphere. 🐾 🐕  #PillionPooch #MadeToTravel #MinPin #AdventureRider #DogsOnAdventures #AdventureDog #Motorcycl<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1534897909925622/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 0.09077<br>                     <strong>Longitude:</strong> 34.53698<br>                     <strong>Date:</strong> Sunday, 1th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_9f6e2dc5165c715ec659ec035882fb76.setContent(
  html_ea857844c46b5b41a8f4b6ed9acc4a31
);

marker_9505dff59504674526193fdf7e1604f1.bindPopup(
  popup_9f6e2dc5165c715ec659ec035882fb76
);

var poly_line_f381ee60c0c4a76397109b2f5bbb20cb = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_1336a58d3a82a19d1b078179d4706362 = L.marker(
  [-0.89548, 36.50622],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_e7efb394a58d8201826465a8ccf40e49 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_1336a58d3a82a19d1b078179d4706362.setIcon(
  icon_e7efb394a58d8201826465a8ccf40e49
);

var popup_efa1911228fcc4acd6de2e437341d52b = L.popup({ maxWidth: "100%" });

var html_62a8c4f38f7fca3872b83600812e3cb7 = $(
  `<div id="html_62a8c4f38f7fca3872b83600812e3cb7" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Kijabe<br>                     <strong>Country:</strong> Kenya<br>                     <strong>Post:</strong> Fun Fact: the equator runs through Uganda. There is an awful lot of land in the northern hemisphere. 🐾 🐕  #PillionPooch #MadeToTravel #MinPin #AdventureRider #DogsOnAdventures #AdventureDog #Motorcycl<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1534897909925622/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> -0.89548<br>                     <strong>Longitude:</strong> 36.50622<br>                     <strong>Date:</strong> Monday, 2th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_efa1911228fcc4acd6de2e437341d52b.setContent(
  html_62a8c4f38f7fca3872b83600812e3cb7
);

marker_1336a58d3a82a19d1b078179d4706362.bindPopup(
  popup_efa1911228fcc4acd6de2e437341d52b
);

var poly_line_432c5f000c72a3d34e9b32348f4e6d7b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_5ca0d17c46ed029cf66baa1e15cebeed = L.marker(
  [0.001, 37.07092],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_d8bbebeb71867eec4be6a6e934f0b2d5 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_5ca0d17c46ed029cf66baa1e15cebeed.setIcon(
  icon_d8bbebeb71867eec4be6a6e934f0b2d5
);

var popup_9b891c2a9fbd4b581d4cc655ec2b88eb = L.popup({ maxWidth: "100%" });

var html_b959549f692a2a2295a08a557f2601ff = $(
  `<div id="html_b959549f692a2a2295a08a557f2601ff" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Nanyuki<br>                     <strong>Country:</strong> Kenya<br>                     <strong>Post:</strong> Shadow is the resident safety officer. One of her jobs is to let us know when our emergency response beacon (SPOT) needs new batteries 🐾 🐕  #PillionPooch #MadeToTravel #MinPin #AdventureRider #DogsOnA<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1540538049361608/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 0.001<br>                     <strong>Longitude:</strong> 37.07092<br>                     <strong>Date:</strong> Sunday, 8th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_9b891c2a9fbd4b581d4cc655ec2b88eb.setContent(
  html_b959549f692a2a2295a08a557f2601ff
);

marker_5ca0d17c46ed029cf66baa1e15cebeed.bindPopup(
  popup_9b891c2a9fbd4b581d4cc655ec2b88eb
);

var poly_line_a12aa24bc62742574cad15e38559bea6 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_865ee1691104e5b27ecb2ffbcd2c770d = L.marker(
  [2.34607, 37.96847],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_7a819f521525cc22b2f92ec9fa829162 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_865ee1691104e5b27ecb2ffbcd2c770d.setIcon(
  icon_7a819f521525cc22b2f92ec9fa829162
);

var popup_58d273f315c9680cc5d7868af34768b6 = L.popup({ maxWidth: "100%" });

var html_298fc28ef548be385fe68433f294dacb = $(
  `<div id="html_298fc28ef548be385fe68433f294dacb" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Marsabit<br>                     <strong>Country:</strong> Kenya<br>                     <strong>Post:</strong> We've returned to Camel country much earlier than we expected in North Kenya. We left Nairobi 2 days ago and the fertile green mountains gave way to semi arid plains. we could see the girls rememberin<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1543201999095213/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 2.34607<br>                     <strong>Longitude:</strong> 37.96847<br>                     <strong>Date:</strong> Monday, 9th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_58d273f315c9680cc5d7868af34768b6.setContent(
  html_298fc28ef548be385fe68433f294dacb
);

marker_865ee1691104e5b27ecb2ffbcd2c770d.bindPopup(
  popup_58d273f315c9680cc5d7868af34768b6
);

var poly_line_5b8092e773f4e7ce1fa65d5e79b29477 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_f1f17654bd6f0578abcb8bb64314dc48 = L.marker(
  [4.11435, 38.28637],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_2a3db2a85d633c4beb5b13a1a4869f76 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_f1f17654bd6f0578abcb8bb64314dc48.setIcon(
  icon_2a3db2a85d633c4beb5b13a1a4869f76
);

var popup_6567d27a26bb117589237554ce7247c9 = L.popup({ maxWidth: "100%" });

var html_7027cfff0b45ac5eeb5cee5571d5b4a1 = $(
  `<div id="html_7027cfff0b45ac5eeb5cee5571d5b4a1" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Mega<br>                     <strong>Country:</strong> Ethiopia<br>                     <strong>Post:</strong> We've returned to Camel country much earlier than we expected in North Kenya. We left Nairobi 2 days ago and the fertile green mountains gave way to semi arid plains. we could see the girls rememberin<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1543201999095213/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 4.11435<br>                     <strong>Longitude:</strong> 38.28637<br>                     <strong>Date:</strong> Tuesday, 10th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_6567d27a26bb117589237554ce7247c9.setContent(
  html_7027cfff0b45ac5eeb5cee5571d5b4a1
);

marker_f1f17654bd6f0578abcb8bb64314dc48.bindPopup(
  popup_6567d27a26bb117589237554ce7247c9
);

var poly_line_ed4131b2029a53409d23e7f0dd2597dd = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_8f5048b7196959523fe1f27f5b092c2b = L.marker(
  [6.41661, 38.30285],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_078c8e2b1f5d5aa5c5e9dd49defa9079 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_8f5048b7196959523fe1f27f5b092c2b.setIcon(
  icon_078c8e2b1f5d5aa5c5e9dd49defa9079
);

var popup_00b8c16da2458e4f09bc9ba73d539ea5 = L.popup({ maxWidth: "100%" });

var html_c268ed08185bcbfcf512114d39b3fc7e = $(
  `<div id="html_c268ed08185bcbfcf512114d39b3fc7e" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Dila<br>                     <strong>Country:</strong> Ethiopia<br>                     <strong>Post:</strong> We've returned to Camel country much earlier than we expected in North Kenya. We left Nairobi 2 days ago and the fertile green mountains gave way to semi arid plains. we could see the girls rememberin<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1543201999095213/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 6.41661<br>                     <strong>Longitude:</strong> 38.30285<br>                     <strong>Date:</strong> Wednesday, 11th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_00b8c16da2458e4f09bc9ba73d539ea5.setContent(
  html_c268ed08185bcbfcf512114d39b3fc7e
);

marker_8f5048b7196959523fe1f27f5b092c2b.bindPopup(
  popup_00b8c16da2458e4f09bc9ba73d539ea5
);

var poly_line_28126c28350ec1501e93a619a0402a21 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_ba597e8eff0e6e1c5c3022e1aadca51c = L.marker(
  [9.0142, 38.78348],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_af44adde0b2fedd1c36047a62d704fac = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_ba597e8eff0e6e1c5c3022e1aadca51c.setIcon(
  icon_af44adde0b2fedd1c36047a62d704fac
);

var popup_f058cb8a0379b336fd55e4b950268c59 = L.popup({ maxWidth: "100%" });

var html_e149a464a840e07cdd71d4e3a68750d7 = $(
  `<div id="html_e149a464a840e07cdd71d4e3a68750d7" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Addis Ababa<br>                     <strong>Country:</strong> Ethiopia<br>                     <strong>Post:</strong> Pet food crisis in Ethiopia. We undertook a major investigation in the capital, Addis Ababa, only to discover that pet food has been banned. Our source, a supermarket manager, explained that there wer<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1551571411591605/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 9.0142<br>                     <strong>Longitude:</strong> 38.78348<br>                     <strong>Date:</strong> Wednesday, 18th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_f058cb8a0379b336fd55e4b950268c59.setContent(
  html_e149a464a840e07cdd71d4e3a68750d7
);

marker_ba597e8eff0e6e1c5c3022e1aadca51c.bindPopup(
  popup_f058cb8a0379b336fd55e4b950268c59
);

var poly_line_601fa23a6b5021c4a627842f752e025e = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_254cc7c2e9acd1f36b4348798852167e = L.marker(
  [11.55165, 39.63914],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_8ec9ceebdf86838e2dacc69786d2e712 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_254cc7c2e9acd1f36b4348798852167e.setIcon(
  icon_8ec9ceebdf86838e2dacc69786d2e712
);

var popup_72cf0be108e10c5ec15663a009be8242 = L.popup({ maxWidth: "100%" });

var html_ecea5403c4b7083732a3d6cf4bdf1bbd = $(
  `<div id="html_ecea5403c4b7083732a3d6cf4bdf1bbd" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Dese<br>                     <strong>Country:</strong> Ethiopia<br>                     <strong>Post:</strong> Pet food crisis in Ethiopia. We undertook a major investigation in the capital, Addis Ababa, only to discover that pet food has been banned. Our source, a supermarket manager, explained that there wer<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1551571411591605/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 11.55165<br>                     <strong>Longitude:</strong> 39.63914<br>                     <strong>Date:</strong> Friday, 20th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_72cf0be108e10c5ec15663a009be8242.setContent(
  html_ecea5403c4b7083732a3d6cf4bdf1bbd
);

marker_254cc7c2e9acd1f36b4348798852167e.bindPopup(
  popup_72cf0be108e10c5ec15663a009be8242
);

var poly_line_1c4bd6368846cbdb967e52759309f153 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_1e3a446aaaa0f9aa34ca55d1058f65a1 = L.marker(
  [11.74915, 38.4726],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_101d3522a170d1521f5fb917a0b3e947 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_1e3a446aaaa0f9aa34ca55d1058f65a1.setIcon(
  icon_101d3522a170d1521f5fb917a0b3e947
);

var popup_1bae536c57d336cd1ad9cf2d66eb9fd2 = L.popup({ maxWidth: "100%" });

var html_d3023f979ef20fbb15bd6768a840d93d = $(
  `<div id="html_d3023f979ef20fbb15bd6768a840d93d" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Debre Tabor<br>                     <strong>Country:</strong> Ethiopia<br>                     <strong>Post:</strong> It's been a delightful ride north west through Ethiopia.  Still a few more days until we cross in to Sudan. 🐾  🐕  #PillionPooch #MadeToTravel #MinPin #AdventureRider #DogsOnAdventures #AdventureDog #M<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1555370357878377" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 11.74915<br>                     <strong>Longitude:</strong> 38.4726<br>                     <strong>Date:</strong> Monday, 23th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_1bae536c57d336cd1ad9cf2d66eb9fd2.setContent(
  html_d3023f979ef20fbb15bd6768a840d93d
);

marker_1e3a446aaaa0f9aa34ca55d1058f65a1.bindPopup(
  popup_1bae536c57d336cd1ad9cf2d66eb9fd2
);

var poly_line_cda10570d6f55f6e8dd7f75ea9c4eb3e = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_f606d0b41f7d6c95b21207981a356fbd = L.marker(
  [12.22912, 37.29893],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_92b28e7ce3c4376d29e66dc62d8bc974 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_f606d0b41f7d6c95b21207981a356fbd.setIcon(
  icon_92b28e7ce3c4376d29e66dc62d8bc974
);

var popup_dba6d458744d95170590bdd3b2a2a196 = L.popup({ maxWidth: "100%" });

var html_4d9dc2ccda3544708ba444fc4d730bc5 = $(
  `<div id="html_4d9dc2ccda3544708ba444fc4d730bc5" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Gondar<br>                     <strong>Country:</strong> Ethiopia<br>                     <strong>Post:</strong> It's been a delightful ride north west through Ethiopia.  Still a few more days until we cross in to Sudan. 🐾  🐕  #PillionPooch #MadeToTravel #MinPin #AdventureRider #DogsOnAdventures #AdventureDog #M<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1555370357878377" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 12.22912<br>                     <strong>Longitude:</strong> 37.29893<br>                     <strong>Date:</strong> Wednesday, 25th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_dba6d458744d95170590bdd3b2a2a196.setContent(
  html_4d9dc2ccda3544708ba444fc4d730bc5
);

marker_f606d0b41f7d6c95b21207981a356fbd.bindPopup(
  popup_dba6d458744d95170590bdd3b2a2a196
);

var poly_line_a05a08f59196a682e8cebe5d779406b0 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_43316879ddb11daa902ae3e8ea8815ec = L.marker(
  [13.02245, 36.0691],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_5461009ee8c55282f7805396151fcbca = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_43316879ddb11daa902ae3e8ea8815ec.setIcon(
  icon_5461009ee8c55282f7805396151fcbca
);

var popup_3fe6d96f54135ab50f709df81547aeab = L.popup({ maxWidth: "100%" });

var html_8ec0dce58593554b7ea78ef6f7cccd33 = $(
  `<div id="html_8ec0dce58593554b7ea78ef6f7cccd33" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Doka<br>                     <strong>Country:</strong> Sudan<br>                     <strong>Post:</strong> We are looking for recent information on entering Egypt without a carnet. Does anyone know someone who has done this lately? Cost and if a refund is possible? Currently in Sudan and contemplating Saud<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1561300190618727/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 13.02245<br>                     <strong>Longitude:</strong> 36.0691<br>                     <strong>Date:</strong> Sunday, 29th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_3fe6d96f54135ab50f709df81547aeab.setContent(
  html_8ec0dce58593554b7ea78ef6f7cccd33
);

marker_43316879ddb11daa902ae3e8ea8815ec.bindPopup(
  popup_3fe6d96f54135ab50f709df81547aeab
);

var poly_line_14c557d1bee8483a702f4c2c0e01bcbd = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_bb66e9829980079d3914b489b1994530 = L.marker(
  [14.0323, 35.04671],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_b914d69fc59294f3bb468ef57186f2b3 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_bb66e9829980079d3914b489b1994530.setIcon(
  icon_b914d69fc59294f3bb468ef57186f2b3
);

var popup_67d45468c3afa821c0d947cbd76b8a1b = L.popup({ maxWidth: "100%" });

var html_ba5a324593ee4974cd7257f03f2478e7 = $(
  `<div id="html_ba5a324593ee4974cd7257f03f2478e7" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Al Qadarif<br>                     <strong>Country:</strong> Sudan<br>                     <strong>Post:</strong> We are looking for recent information on entering Egypt without a carnet. Does anyone know someone who has done this lately? Cost and if a refund is possible? Currently in Sudan and contemplating Saud<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1561300190618727/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 14.0323<br>                     <strong>Longitude:</strong> 35.04671<br>                     <strong>Date:</strong> Monday, 30th of October 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_67d45468c3afa821c0d947cbd76b8a1b.setContent(
  html_ba5a324593ee4974cd7257f03f2478e7
);

marker_bb66e9829980079d3914b489b1994530.bindPopup(
  popup_67d45468c3afa821c0d947cbd76b8a1b
);

var poly_line_393abe3540874fcd8e78a558ae45762b = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_d9994c407d2d5d83b9bd2aa7827bc331 = L.marker(
  [15.59952, 32.55798],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_d5c22765fb4b902cf3107ed17de61ea1 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_d9994c407d2d5d83b9bd2aa7827bc331.setIcon(
  icon_d5c22765fb4b902cf3107ed17de61ea1
);

var popup_368f91d3844ecf56d9d11d25c4c98099 = L.popup({ maxWidth: "100%" });

var html_efbbdc88f617658727854d0f1d0a653d = $(
  `<div id="html_efbbdc88f617658727854d0f1d0a653d" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Khartoum<br>                     <strong>Country:</strong> Sudan<br>                     <strong>Post:</strong> We are looking for recent information on entering Egypt without a carnet. Does anyone know someone who has done this lately? Cost and if a refund is possible? Currently in Sudan and contemplating Saud<br>                     <strong>Link: <a href="https://www.facebook.com/538341119581311/posts/1561300190618727/" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 15.59952<br>                     <strong>Longitude:</strong> 32.55798<br>                     <strong>Date:</strong> Friday, 3th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_368f91d3844ecf56d9d11d25c4c98099.setContent(
  html_efbbdc88f617658727854d0f1d0a653d
);

marker_d9994c407d2d5d83b9bd2aa7827bc331.bindPopup(
  popup_368f91d3844ecf56d9d11d25c4c98099
);

var poly_line_0f8656e1191974ced26ae90b331a47fa = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_bab07de3891c3eb4bb6e9cc04697425c = L.marker(
  [16.66303, 33.45339],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_5ac8754c2c816608b7571690351bf92b = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_bab07de3891c3eb4bb6e9cc04697425c.setIcon(
  icon_5ac8754c2c816608b7571690351bf92b
);

var popup_073c96147e99557ad1b332b2a802b414 = L.popup({ maxWidth: "100%" });

var html_b562377bb4acccf794eab7a4a3a721d3 = $(
  `<div id="html_b562377bb4acccf794eab7a4a3a721d3" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Shendi<br>                     <strong>Country:</strong> Sudan<br>                     <strong>Post:</strong> If they leaned out any further the passenger and driver of the tuk tuk would fall out 🐾 🐕  #PillionPooch #MadeToTravel #MinPin #AdventureRider #DogsOnAdventures #AdventureDog #MotorcycleAdventure #Pet<br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1568365423245537/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 16.66303<br>                     <strong>Longitude:</strong> 33.45339<br>                     <strong>Date:</strong> Sunday, 5th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_073c96147e99557ad1b332b2a802b414.setContent(
  html_b562377bb4acccf794eab7a4a3a721d3
);

marker_bab07de3891c3eb4bb6e9cc04697425c.bindPopup(
  popup_073c96147e99557ad1b332b2a802b414
);

var poly_line_2394621b1bc5906b097a2108a7336c64 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_9a748e2596238c15d83237cdbb9b8182 = L.marker(
  [15.56799, 32.5638],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_2ef5e51117a19f4bf19a5213e231e3f6 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_9a748e2596238c15d83237cdbb9b8182.setIcon(
  icon_2ef5e51117a19f4bf19a5213e231e3f6
);

var popup_bb63edf4a72026277046dd2ed51afacf = L.popup({ maxWidth: "100%" });

var html_581e603242febe794ba42806c175e93e = $(
  `<div id="html_581e603242febe794ba42806c175e93e" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Khartoum<br>                     <strong>Country:</strong> Sudan<br>                     <strong>Post:</strong> Wild camping in Sudan. We've been so lucky to be in mountains and cool temperatures since South Africa,  but now it's very hot and dry. And for some reason Stu is getting all sorts of nasty bites all <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1568560046559408/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 15.56799<br>                     <strong>Longitude:</strong> 32.5638<br>                     <strong>Date:</strong> Friday, 10th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_bb63edf4a72026277046dd2ed51afacf.setContent(
  html_581e603242febe794ba42806c175e93e
);

marker_9a748e2596238c15d83237cdbb9b8182.bindPopup(
  popup_bb63edf4a72026277046dd2ed51afacf
);

var poly_line_9ef25329c6278ed50b88aef0c0c9b3a5 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
    [15.56799, 32.5638],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_1bfdb8f9fa1369e7bca85fb852f9c406 = L.marker(
  [18.30751, 30.67702],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_a28ec83090a0655f28e3952b0ab5e89b = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_1bfdb8f9fa1369e7bca85fb852f9c406.setIcon(
  icon_a28ec83090a0655f28e3952b0ab5e89b
);

var popup_c90354ce71700819dacd866484240b1f = L.popup({ maxWidth: "100%" });

var html_27fee015f8f850b8e58071924883b0d4 = $(
  `<div id="html_27fee015f8f850b8e58071924883b0d4" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ad Dabbah<br>                     <strong>Country:</strong> Sudan<br>                     <strong>Post:</strong> Wild camping in Sudan. We've been so lucky to be in mountains and cool temperatures since South Africa,  but now it's very hot and dry. And for some reason Stu is getting all sorts of nasty bites all <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1568560046559408/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 18.30751<br>                     <strong>Longitude:</strong> 30.67702<br>                     <strong>Date:</strong> Saturday, 11th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_c90354ce71700819dacd866484240b1f.setContent(
  html_27fee015f8f850b8e58071924883b0d4
);

marker_1bfdb8f9fa1369e7bca85fb852f9c406.bindPopup(
  popup_c90354ce71700819dacd866484240b1f
);

var poly_line_090cdc05c606ac8635bd3b21b3b81a9f = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
    [15.56799, 32.5638],
    [18.30751, 30.67702],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_2dcd64d7cf313247727a2ea947384bd9 = L.marker(
  [21.8041, 31.36537],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_2dbde211b42b433cd1eae5d0e06249d6 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_2dcd64d7cf313247727a2ea947384bd9.setIcon(
  icon_2dbde211b42b433cd1eae5d0e06249d6
);

var popup_aa8e867b527157486e59700afbd289d9 = L.popup({ maxWidth: "100%" });

var html_7dc98d2917793cb440f2399569d06069 = $(
  `<div id="html_7dc98d2917793cb440f2399569d06069" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Abu Sunbul<br>                     <strong>Country:</strong> Egypt<br>                     <strong>Post:</strong> Wild camping in Sudan. We've been so lucky to be in mountains and cool temperatures since South Africa,  but now it's very hot and dry. And for some reason Stu is getting all sorts of nasty bites all <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1568560046559408/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 21.8041<br>                     <strong>Longitude:</strong> 31.36537<br>                     <strong>Date:</strong> Tuesday, 14th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_aa8e867b527157486e59700afbd289d9.setContent(
  html_7dc98d2917793cb440f2399569d06069
);

marker_2dcd64d7cf313247727a2ea947384bd9.bindPopup(
  popup_aa8e867b527157486e59700afbd289d9
);

var poly_line_b1e0ffbd6a8c1966c437e9503b2f3d91 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
    [15.56799, 32.5638],
    [18.30751, 30.67702],
    [21.8041, 31.36537],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_878e362e0d1c1e16d3f7eb5f651e66c4 = L.marker(
  [24.03853, 32.88189],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_0f6acaae8d2bfe09404675d04a0e98f7 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_878e362e0d1c1e16d3f7eb5f651e66c4.setIcon(
  icon_0f6acaae8d2bfe09404675d04a0e98f7
);

var popup_1895f33687a5f8837c15822feae2faf1 = L.popup({ maxWidth: "100%" });

var html_083133f66f23fc1e8e0a59584286c09f = $(
  `<div id="html_083133f66f23fc1e8e0a59584286c09f" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Aswan<br>                     <strong>Country:</strong> Egypt<br>                     <strong>Post:</strong> Janell was hit by a speeding Mini Bus in Sudan She fractured her collarbone but is otherwise fine. Stuart, riding up front, turned left to enter a site with pyramids. This meant crossing the oncoming <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1584290291653050/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 24.03853<br>                     <strong>Longitude:</strong> 32.88189<br>                     <strong>Date:</strong> Thursday, 23th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_1895f33687a5f8837c15822feae2faf1.setContent(
  html_083133f66f23fc1e8e0a59584286c09f
);

marker_878e362e0d1c1e16d3f7eb5f651e66c4.bindPopup(
  popup_1895f33687a5f8837c15822feae2faf1
);

var poly_line_69820b484e7a8d6adbc008c923c2ed05 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
    [15.56799, 32.5638],
    [18.30751, 30.67702],
    [21.8041, 31.36537],
    [24.03853, 32.88189],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_b0754fb5a00e9471d779b2788fdd9079 = L.marker(
  [26.86041, 31.12397],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_c85834e875f50f8dfb7465ce247cbe10 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_b0754fb5a00e9471d779b2788fdd9079.setIcon(
  icon_c85834e875f50f8dfb7465ce247cbe10
);

var popup_e24dab77349be858c15be949ed0da3aa = L.popup({ maxWidth: "100%" });

var html_2408bbd619effea95b39e1696502ff29 = $(
  `<div id="html_2408bbd619effea95b39e1696502ff29" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Abu Tij<br>                     <strong>Country:</strong> Egypt<br>                     <strong>Post:</strong> We have so much drama in our posts lately (there's more to come) so it's important to focus on the things going right...Our dogs are safe and well and THAT is the very most important thing to us 🐾 🐕  <br>                     <strong>Link: <a href="https://www.facebook.com/Thepacktrack/photos/a.644909472257808/1585848578163888/?type=3" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 26.86041<br>                     <strong>Longitude:</strong> 31.12397<br>                     <strong>Date:</strong> Friday, 24th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_e24dab77349be858c15be949ed0da3aa.setContent(
  html_2408bbd619effea95b39e1696502ff29
);

marker_b0754fb5a00e9471d779b2788fdd9079.bindPopup(
  popup_e24dab77349be858c15be949ed0da3aa
);

var poly_line_4cfac9fd8e29ba152e6f457ed5e92570 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
    [15.56799, 32.5638],
    [18.30751, 30.67702],
    [21.8041, 31.36537],
    [24.03853, 32.88189],
    [26.86041, 31.12397],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_29c5fb3692e35ef54e1ad38d0c28becd = L.marker(
  [28.89064, 30.74217],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_505f248937823949ba22e37700577583 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_29c5fb3692e35ef54e1ad38d0c28becd.setIcon(
  icon_505f248937823949ba22e37700577583
);

var popup_a2138e303db428bbba04796d78717dfc = L.popup({ maxWidth: "100%" });

var html_2ff2f80dcde2f5a83e5815741cb9864f = $(
  `<div id="html_2ff2f80dcde2f5a83e5815741cb9864f" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Sumusta as Sultani<br>                     <strong>Country:</strong> Egypt<br>                     <strong>Post:</strong> F650GS water pump repair in Sudan It took us 3 attempts to leave Khartoum and ride to the Egyptian border. First attempt was the accident, second attempt we discovered water in Janells oil (we discuss<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1587579101324169" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 28.89064<br>                     <strong>Longitude:</strong> 30.74217<br>                     <strong>Date:</strong> Sunday, 26th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_a2138e303db428bbba04796d78717dfc.setContent(
  html_2ff2f80dcde2f5a83e5815741cb9864f
);

marker_29c5fb3692e35ef54e1ad38d0c28becd.bindPopup(
  popup_a2138e303db428bbba04796d78717dfc
);

var poly_line_439c4d04a71d32301982fe486d9b3ee0 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
    [15.56799, 32.5638],
    [18.30751, 30.67702],
    [21.8041, 31.36537],
    [24.03853, 32.88189],
    [26.86041, 31.12397],
    [28.89064, 30.74217],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_0a1f1ab6f1c819360c74895e4f49ede9 = L.marker(
  [30.60068, 32.20801],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_830c41b3587a7c37d7ab0e7fa5b8daef = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_0a1f1ab6f1c819360c74895e4f49ede9.setIcon(
  icon_830c41b3587a7c37d7ab0e7fa5b8daef
);

var popup_a1ae8654eab0dd8a1da26fa94579d529 = L.popup({ maxWidth: "100%" });

var html_48059b2f9b3465930a348797ed492305 = $(
  `<div id="html_48059b2f9b3465930a348797ed492305" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Ismailia<br>                     <strong>Country:</strong> Egypt<br>                     <strong>Post:</strong> F650GS water pump repair in Sudan It took us 3 attempts to leave Khartoum and ride to the Egyptian border. First attempt was the accident, second attempt we discovered water in Janells oil (we discuss<br>                     <strong>Link: <a href="https://www.facebook.com/1157909055503171/videos/1587579101324169" target="_blank">Facebook 🔗</a></strong><br>                     <strong>Latitude:</strong> 30.60068<br>                     <strong>Longitude:</strong> 32.20801<br>                     <strong>Date:</strong> Monday, 27th of November 2017<br>                     <strong>Source:</strong> SPOT GPS Tracker<br>                     <strong>Location Accuracy:</strong> 100.0<br>                 </div>             </div>`
)[0];
popup_a1ae8654eab0dd8a1da26fa94579d529.setContent(
  html_48059b2f9b3465930a348797ed492305
);

marker_0a1f1ab6f1c819360c74895e4f49ede9.bindPopup(
  popup_a1ae8654eab0dd8a1da26fa94579d529
);

var poly_line_315c58cd3b8399a0dba2e06f6d83b23f = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
    [15.56799, 32.5638],
    [18.30751, 30.67702],
    [21.8041, 31.36537],
    [24.03853, 32.88189],
    [26.86041, 31.12397],
    [28.89064, 30.74217],
    [30.60068, 32.20801],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);

tile_layer_03e5463fda3f7614d0652bb98b89167c.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

marker_cluster_110900f70bd3720a4c657036f1528ec7.addTo(
  map_0d5da40de8d924d648e48bbfdd0bd93a
);

var marker_7a8f117521f9a2395b529b2114ab72e7 = L.marker(
  [52.1793816, -1.698648],
  {}
).addTo(marker_cluster_110900f70bd3720a4c657036f1528ec7);

var icon_f88ea2096cbb54d7bf92fe76fc59cf73 = L.AwesomeMarkers.icon({
  extraClasses: "fa-rotate-0",
  icon: "info-sign",
  iconColor: "white",
  markerColor: "red",
  prefix: "glyphicon",
});
marker_7a8f117521f9a2395b529b2114ab72e7.setIcon(
  icon_f88ea2096cbb54d7bf92fe76fc59cf73
);

var popup_5cd802c943f3430b8aae995a95ab54d5 = L.popup({ maxWidth: "100%" });

var html_fbe8356f1e17e45db85e8440c17cd0d8 = $(
  `<div id="html_fbe8356f1e17e45db85e8440c17cd0d8" style="width: 100.0%; height: 100.0%;">                 <div style="width: 200px;">                     <strong>City:</strong> Stratford-upon-Avon<br>                     <strong>Country:</strong> United Kingdom<br>                                                               <strong>Latitude:</strong> 52.1793816<br>                     <strong>Longitude:</strong> -1.698648<br>                     <strong>Date:</strong> Wednesday, 27th of December 2017<br>                     <strong>Source:</strong> Google Timeline<br>                     <strong>Location Accuracy:</strong> 99.16104<br>                 </div>             </div>`
)[0];
popup_5cd802c943f3430b8aae995a95ab54d5.setContent(
  html_fbe8356f1e17e45db85e8440c17cd0d8
);

marker_7a8f117521f9a2395b529b2114ab72e7.bindPopup(
  popup_5cd802c943f3430b8aae995a95ab54d5
);

var poly_line_a11282514d5dda6573e4989497f47702 = L.polyline(
  [
    [31.606445, -7.825859],
    [33.535643, -7.78021],
    [32.3140529, -9.2333757],
    [31.3524003, -9.7949087],
    [30.42606, -9.59188],
    [28.49085, -11.33771],
    [27.952836, -12.865686],
    [26.13262, -14.49496],
    [23.78181, -15.90115],
    [22.05488, -16.74722],
    [20.9245, -16.21606],
    [18.11173, -16.0264],
    [16.22107, -16.41449],
    [14.6899365, -17.4732781],
    [13.977, -14.81747],
    [12.9016087, -14.947223],
    [13.26055, -13.20166],
    [12.67946, -11.09744],
    [12.625496, -7.988058],
    [10.84124, -4.78226],
    [11.7508293, -2.9289838],
    [12.3178, -1.5285],
    [12.07375, 0.33459],
    [9.69153, 1.65943],
    [7.22995, 2.43334],
    [6.5818185, 3.3211348],
    [8.1541, 4.25669],
    [7.46863, 4.89143],
    [6.6228982, 3.3571165],
    [6.72077, 4.87544],
    [6.16126, 6.74835],
    [4.99355, 8.35313],
    [6.443742, 2.6364933],
    [4.95104, 8.31387],
    [5.96579, 8.72317],
    [4.62909, 9.44228],
    [3.893211, 11.512039],
    [2.37816, 11.34398],
    [0.0892, 11.08074],
    [0.378, 9.45472],
    [-2.41679, 11.44713],
    [-3.48637, 12.32368],
    [-4.83415, 11.88315],
    [-10.74034, 14.98117],
    [-12.62257, 13.34107],
    [-14.92365, 13.47621],
    [-17.21175, 14.67346],
    [-18.69547, 13.74345],
    [-19.9243, 13.98478],
    [-21.21834, 14.86787],
    [-22.6566275, 14.5493917],
    [-22.619111, 17.094296],
    [-27.36668, 18.54707],
    [-29.6862, 17.88821],
    [-27.4453, 23.48806],
    [-25.93744, 27.97628],
    [-26.61093, 27.28995],
    [-28.73978, 24.75205],
    [-30.58723, 23.50636],
    [-31.4624788, 19.800442],
    [-33.0493581, 18.0649076],
    [-33.88377, 18.65462],
    [-33.52701, 21.74158],
    [-34.2109619, 24.835235],
    [-32.8668053, 28.0638896],
    [-31.61665, 29.54288],
    [-29.8289571, 31.0303869],
    [-28.766577, 32.112225],
    [-23.9883848, 31.5547402],
    [-28.58984, 31.39697],
    [-27.73599, 29.98165],
    [-26.1453, 28.15282],
    [-28.643295, 29.158825],
    [-27.71397, 29.92232],
    [-28.76607, 32.11327],
    [-29.37294, 31.18832],
    [-27.74179, 30.72241],
    [-26.20183, 31.19853],
    [-25.71761, 28.26542],
    [-22.47678, 27.16376],
    [-21.20041, 27.5224],
    [-18.67928, 26.94052],
    [-17.92937, 25.8383],
    [-16.8298, 26.93745],
    [-15.40834, 28.28104],
    [-14.44144, 28.44905],
    [-13.05101, 28.46319],
    [-12.36581, 27.48194],
    [-13.05788, 28.45596],
    [-13.53668, 29.73036],
    [-11.84549, 31.44656],
    [-8.87086, 31.33826],
    [-8.93092, 33.30932],
    [-7.75603, 35.70664],
    [-6.02933, 35.75672],
    [-3.36664, 36.71092],
    [-3.13345, 37.60715],
    [-3.37721, 35.82771],
    [-4.70145, 34.69961],
    [-4.21892, 33.15663],
    [-2.49969, 30.85266],
    [-1.95403, 30.09906],
    [-0.26894, 31.81332],
    [0.27088, 32.56564],
    [0.09077, 34.53698],
    [-0.89548, 36.50622],
    [0.001, 37.07092],
    [2.34607, 37.96847],
    [4.11435, 38.28637],
    [6.41661, 38.30285],
    [9.0142, 38.78348],
    [11.55165, 39.63914],
    [11.74915, 38.4726],
    [12.22912, 37.29893],
    [13.02245, 36.0691],
    [14.0323, 35.04671],
    [15.59952, 32.55798],
    [16.66303, 33.45339],
    [15.56799, 32.5638],
    [18.30751, 30.67702],
    [21.8041, 31.36537],
    [24.03853, 32.88189],
    [26.86041, 31.12397],
    [28.89064, 30.74217],
    [30.60068, 32.20801],
    [52.1793816, -1.698648],
  ],
  {
    bubblingMouseEvents: true,
    color: "blue",
    dashArray: null,
    dashOffset: null,
    fill: false,
    fillColor: "blue",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    lineCap: "round",
    lineJoin: "round",
    noClip: false,
    opacity: 1.0,
    smoothFactor: 1.0,
    stroke: true,
    weight: 3,
  }
).addTo(map_0d5da40de8d924d648e48bbfdd0bd93a);
